module.exports = `
directive @oneOf on INPUT_OBJECT

directive @specifiedBy(
  url: String!
) on SCALAR

directive @client(
  always: Boolean
) on FIELD | FRAGMENT_DEFINITION | INLINE_FRAGMENT

directive @export(
  as: String!
) on FIELD

directive @connection(
  key: String!

  filter: [String!]
) on FIELD

input Altinn3AmeldingCancelInput {
  clientMutationId: String
  ameldingId: ID!
}

type Altinn3AmeldingCancelPayload {
  amelding: Amelding

  clientMutationId: String
}

input Altinn3AmeldingSendInput {
  clientMutationId: String
  unitId: ID!
  data: AmeldingDataInput!
}

type Altinn3AmeldingSendPayload {
  amelding: Amelding

  clientMutationId: String
}

type Altinn3Submission {
  feedbackReady: Boolean!
  humanStatus: String!
  id: ID!
  parent: Altinn3SubmissionTypePolymorphicParent!
  pending: Boolean!
  receivedFeedback: Boolean!
  sendingStatus: String!
  sentAt: DateTime!
  sentBy: User!
  unit: Unit!
}

input Altinn3SubmissionCheckStatusInput {
  clientMutationId: String
  altinn3SubmissionId: ID!
}

type Altinn3SubmissionCheckStatusPayload {
  altinn3Submission: Altinn3Submission!

  clientMutationId: String
}

input Altinn3SubmissionFeedbackGetInput {
  clientMutationId: String
  altinn3SubmissionId: ID!
}

type Altinn3SubmissionFeedbackGetPayload {
  altinn3Submission: Altinn3Submission!

  clientMutationId: String
}

union Altinn3SubmissionTypePolymorphicParent = Amelding | AmeldingReconciliationReport

input Altinn3SystemUserRefreshStatusInput {
  clientMutationId: String
}

type Altinn3SystemUserRefreshStatusPayload {
  clientMutationId: String
  newStatus: UnitPaycheckSettingsAltinn3SystemUserStatusEnum
  unitPaycheckSetting: UnitPaycheckSetting
}

input Altinn3SystemUserRegisterInput {
  clientMutationId: String
  withDeleteRequest: Boolean
}

type Altinn3SystemUserRegisterPayload {
  clientMutationId: String
  confirmationUrl: String
}

enum AltinnEmploymentDurationTypeEnum {
  fast
  midlertidig
  fastAnsattUtleid
  midlertidigAnsattUtleid
  midlertidigAnsattSomTilkallingsvikar
}

enum AltinnEmploymentEndReasonEnum {
  arbeidsforholdetSkulleAldriVaertRapportert
  arbeidsgiverHarSagtOppArbeidstaker
  arbeidstakerHarSagtOppSelv
  byttetLoenssystemEllerRegnskapsfoerer
  endringIOrganisasjonsstrukturEllerByttetJobbInternt
  kontraktEngasjementEllerVikariatErUtloept
}

enum AltinnEmploymentTypeEnum {
  frilanserOppdragstakerHonorarPersonerMm
  maritimtArbeidsforhold
  ordinaertArbeidsforhold
  pensjonOgAndreTyperYtelserUtenAnsettelsesforhold
}

enum AltinnFordelEnum {
  kontantytelse
  naturalytelse
  utgiftsgodtgjoerelse
}

enum AltinnIncomeDescriptionEnum {
  administrativForpleining
  aksjerGrunnfondsbevisTilUnderkurs
  annet
  arbeidsoppholdKost
  arbeidsoppholdLosji
  bedriftsbarnehageplass
  beregnetSkatt
  besoeksreiserHjemmetAnnet
  besoeksreiserHjemmetKilometergodtgjoerelseBil
  besoeksreiserHjemmetKost
  bil
  bolig
  bonus
  bonusFraForsvaret
  elektroniskKommunikasjon
  fastBilgodtgjoerelse
  fastTillegg
  fastloenn
  feriepenger
  flyttegodtgjoerelse
  fondForIdrettsutoevere
  friTransport
  godtgjoerelseSaeravtaleUtland
  helligdagstillegg
  hyretillegg
  ikkeSkattepliktigLoennFraUtenlandskDiplomKonsulStasjon
  kapitalInntekt
  kilometergodtgjoerelseAndreFremkomstmidler
  kilometergodtgjoerelseBil
  kilometergodtgjoerelseElBil
  kilometergodtgjoerelsePassasjertillegg
  kommunalOmsorgsloennOgFosterhjemsgodtgjoerelse
  kompensasjonstilleggBolig
  kostDager
  kostDoegn
  kostbesparelseIHjemmet
  losji
  losjiEgenBrakkeCampingvogn
  loennForBarnepassIBarnetsHjem
  loennTilPrivatpersonerForArbeidIHjemmet
  loennTilVergeFraStatsforvalteren
  loennUtbetaltAvVeldedigEllerAllmennyttigInstitusjonEllerOrganisasjon
  loennUtenlandskArtist
  opsjoner
  overtidsgodtgjoerelse
  overtidsmat
  reiseAnnet
  reiseKost
  reiseKostMedOvernattingPaaHotell
  reiseKostMedOvernattingPaaHotellBeordringUtover28Doegn
  reiseKostMedOvernattingPaaHybelBrakkePrivat
  reiseKostMedOvernattingPaaPensjonat
  reiseKostMedOvernattingPaaHybelMedKokEllerPrivat
  reiseKostMedOvernattingPaaHybelUtenKokEllerPensjonatEllerBrakke
  reiseKostMedOvernattingTilLangtransportsjaafoerForKjoeringIUtlandet
  reiseKostMedOvernattingTilLangtransportsjaafoerForKjoeringInnenlands
  reiseKostUtenOvernatting
  reiseLosji
  reiseNattillegg
  rentefordelLaan
  skattefriErstatning
  skattefrieUtbetalinger
  skattepliktigDelForsikringer
  skattepliktigGodtgjoerelseSaeravtaleUtland
  sluttvederlag
  smusstillegg
  stipend
  styrehonorarOgGodtgjoerelseVerv
  tilskuddBarnehageplass
  timeloenn
  uregelmessigeTilleggKnyttetTilArbeidetTid
  uregelmessigeTilleggKnyttetTilIkkeArbeidetTid
  loennEtterDoedsfall
  yrkebilTjenestligbehovKilometer
  yrkebilTjenestligbehovListepris
  innbetalingTilUtenlandskPensjonsordning
  loennTilVergeFraFylkesmannen
  trekkILoennForFerie
  betaltUtenlandskSkatt
  honorarAkkordProsentProvisjon
  skattepliktigPersonalrabatt
  tips
}

enum AltinnLeaveAndLayoffDescriptionEnum {
  permisjon
  permittering
  permisjonMedForeldrepenger
  permisjonVedMilitaertjeneste
  utdanningspermisjon
  velferdspermisjon
  andreIkkeLovfestedePermisjoner
  andreLovfestedePermisjoner
  utdanningspermisjonIkkeLovfestet
  utdanningspermisjonLovfestet
}

enum AltinnShiftTypeEnum {
  offshore336
  doegnkontinuerligSkiftOgTurnus355
  helkontinuerligSkiftOgAndreOrdninger336
  ikkeSkift
  andreSkift
  skift365
}

type AltinnSubmission {
  archiveHistory: String
  archiveReference: String
  archived: Boolean!
  archivedAt: DateTime
  correspondenceTitle: String
  humanStatus: String!
  id: ID!
  parent: AltinnSubmissionTypePolymorphicParent!
  pending: Boolean!
  processedAt: DateTime
  receiptId: String
  receiptText: String
  receivedFeedback: Boolean!
  receiversReference: String
  sendingStatus: String!
  sentAt: DateTime!
  sentBy: User!
  submitHistory: String
  unit: Unit!
}

union AltinnSubmissionTypePolymorphicParent = Amelding | AmeldingReconciliationReport

type AltinnTaxInvoicePreview {
  altinnReference: String
  amount: Decimal!
  bban: String!
  calendarMonth: String!
  companyName: String!
  dueDate: Date
  kid: String
  messages: [AltinnTaxInvoicePreviewMessage!]!
  organizationNumber: String!
  taxCollectorUnit: Unit!
  type: String!
}

type AltinnTaxInvoicePreviewMessage {
  altinnReference: String
  amount: Decimal!
  deliveredAt: DateTime!
  receivers: Int!
  replacedByAltinnReference: String
}

input AltinnTaxSendToFbInput {
  clientMutationId: String
  unitId: ID!
  calendarMonth: String!
}

type AltinnTaxSendToFbPayload {
  clientMutationId: String
  failures: [String!]!
  successes: Int!
}

type Amelding {
  aMeldingJson: Attachment
  aMeldingXml: Attachment
  altinn3Submission: Altinn3Submission
  altinnSubmission: AltinnSubmission
  ameldingPensionAmounts: [AmeldingPensionAmount!]!
  ameldingReference: String
  ameldingReimbursements: [AmeldingReimbursement!]!
  ameldingToReplace: Amelding
  ameldingWorkRelations: [AmeldingWorkRelation!]!
  calendarMonth: String!
  cancellation: Boolean!
  failureMessage: String
  feedbackDeviations: [AmeldingFeedbackDeviation!]!
  feedbackJson: Attachment
  feedbackXml: Attachment
  humanStatus: String!
  id: ID!
  isResendable: Boolean
  paychecks: [Paycheck!]!
  replacementAmelding: Amelding
  unit: Unit!
}

input AmeldingAccountSelectionSave {
  id: ID
  _destroy: Boolean
  number: String
  employeeTaxDeduction: Boolean
}

input AmeldingAccountSelectionsSaveInput {
  clientMutationId: String
  unitId: ID!
  ameldingAccountSelections: [AmeldingAccountSelectionSave!]!
}

type AmeldingAccountSelectionsSavePayload {
  clientMutationId: String
  unit: Unit!
}

type AmeldingAndBookkeepingReconciliationReportAccountSelection {
  employeeTaxDeduction: Boolean!
  id: ID!
  number: String!
}

type AmeldingAndBookkeepingReconciliationReportBookkeptTable {
  agaSection: String!
  ftrSection: String!
}

type AmeldingAndBookkeepingReconciliationReportDiffTable {
  monthly: [AmeldingAndBookkeepingReconciliationReportDiffTableMonthRow!]!
  paychecksInYearNotPaidInYear: AmeldingAndBookkeepingReconciliationReportDiffTableRow!
  paychecksNotInYearPaidInYear: AmeldingAndBookkeepingReconciliationReportDiffTableRow!
  sums: AmeldingAndBookkeepingReconciliationReportDiffTableRow!
  sumsWithPaychecks: AmeldingAndBookkeepingReconciliationReportDiffTableRow!
}

type AmeldingAndBookkeepingReconciliationReportDiffTableMonthRow {
  agaBaseAccumulated: Decimal!
  agaBaseDiff: Decimal!
  agaCalculated: Decimal!
  agaDiff: Decimal!
  agaReported: Decimal!
  ftrBookkept: Decimal!
  ftrDiff: Decimal!
  ftrReported: Decimal!
  month: String!
}

type AmeldingAndBookkeepingReconciliationReportDiffTableRow {
  agaBaseAccumulated: Decimal!
  agaBaseDiff: Decimal!
  agaCalculated: Decimal!
  agaDiff: Decimal!
  agaReported: Decimal!
  ftrBookkept: Decimal!
  ftrDiff: Decimal!
  ftrReported: Decimal!
}

type AmeldingAndBookkeepingReconciliationReportFbBookkeepingAccount {
  id: ID!
  name: String!
  number: String!
}

type AmeldingAndBookkeepingReconciliationReportPaychecksInYearNotPaidInYearFooter {
  columnSums: [Decimal!]!
  employerTax: Decimal!
  employerTaxBase: Decimal!
  employerTaxOfVacationMoney: Decimal!
  taxDeduction: Decimal!
  vacationMoney: Decimal!
}

type AmeldingAndBookkeepingReconciliationReportPaychecksInYearNotPaidInYearRow {
  employerTax: Decimal!
  employerTaxBase: Decimal!
  employerTaxOfVacationMoney: Decimal!
  lineSums: [Decimal!]!
  paycheckId: ID!
  paycheckNumber: String!
  taxDeduction: Decimal!
  vacationMoney: Decimal!
  workRelation: WorkRelation!
}

type AmeldingAndBookkeepingReconciliationReportPaychecksInYearNotPaidInYearTable {
  footer: AmeldingAndBookkeepingReconciliationReportPaychecksInYearNotPaidInYearFooter!
  headers: [String!]!
  rows: [AmeldingAndBookkeepingReconciliationReportPaychecksInYearNotPaidInYearRow!]!
}

type AmeldingAndBookkeepingReconciliationReportPaychecksNotInYearPaidInYearFooter {
  columnSums: [Decimal!]!
  employerTax: Decimal!
  employerTaxBase: Decimal!
  employerTaxOfVacationMoney: Decimal!
  taxDeduction: Decimal!
  vacationMoney: Decimal!
}

type AmeldingAndBookkeepingReconciliationReportPaychecksNotInYearPaidInYearRow {
  employerTax: Decimal!
  employerTaxBase: Decimal!
  employerTaxOfVacationMoney: Decimal!
  lineSums: [Decimal!]!
  paycheckId: ID!
  paycheckNumber: String!
  taxDeduction: Decimal!
  vacationMoney: Decimal!
  workRelation: WorkRelation!
}

type AmeldingAndBookkeepingReconciliationReportPaychecksNotInYearPaidInYearTable {
  footer: AmeldingAndBookkeepingReconciliationReportPaychecksNotInYearPaidInYearFooter!
  headers: [String!]!
  rows: [AmeldingAndBookkeepingReconciliationReportPaychecksNotInYearPaidInYearRow!]!
}

type AmeldingAndBookkeepingReconciliationReportReconciliationReport {
  calendarMonth: String!
  createdBy: User!
  employerTax: Decimal!
  id: ID!
  pension: Decimal!
  reimbursement: Decimal!
  runningEmployerTaxBase: Decimal!
  salary: Decimal!
  statusAt: DateTime!
  taxDeduction: Decimal!
  unit: Unit!
}

type AmeldingAndBookkeepingReconciliationReportReconciliationReports {
  reports: [AmeldingAndBookkeepingReconciliationReportReconciliationReport!]!
  sum: AmeldingAndBookkeepingReconciliationReportReconciliationReportSums!
}

type AmeldingAndBookkeepingReconciliationReportReconciliationReportSums {
  employerTax: Decimal!
  employerTaxBase: Decimal!
  pension: Decimal!
  reimbursement: Decimal!
  salary: Decimal!
  taxDeduction: Decimal!
}

type AmeldingAndBookkeepingReconciliationReportRoot {
  bookkeptTable: AmeldingAndBookkeepingReconciliationReportBookkeptTable!
  diffTable: AmeldingAndBookkeepingReconciliationReportDiffTable!
  mostRecentAmeldingReconciliationReports: AmeldingAndBookkeepingReconciliationReportReconciliationReports!
  paychecksInYearNotPaidInYearTable: AmeldingAndBookkeepingReconciliationReportPaychecksInYearNotPaidInYearTable!
  paychecksNotInYearPaidInYearTable: AmeldingAndBookkeepingReconciliationReportPaychecksNotInYearPaidInYearTable!
  year: Int!
}

input AmeldingDataInput {
  calendarMonth: String!
  paycheckIds: [ID!] = []
  ameldingWorkRelations: [AmeldingDataInputTypeAmeldingWorkRelationSend!] = []
  pensionAmounts: [AmeldingDataInputTypeAmeldingPensionAmountSend!]
  reimbursements: [AmeldingDataInputTypeAmeldingReimbursementSend!] = []
  ameldingToReplaceId: ID
}

input AmeldingDataInputTypeAmeldingPensionAmountSend {
  amount: Decimal!
  subUnitId: ID!
  employerTaxZoneId: ID!
}

input AmeldingDataInputTypeAmeldingReimbursementSend {
  amount: Decimal!
  subUnitId: ID!
  employerTaxZoneId: ID!
}

input AmeldingDataInputTypeAmeldingWorkRelationSend {
  workRelationId: ID!
  subUnitId: ID!
  startDate: Date
  endDate: Date
  endReason: AltinnEmploymentEndReasonEnum
  occupationId: ID
  samePositionSince: Date
  shiftType: AltinnShiftTypeEnum
  employeeId: ID!
  employmentType: AltinnEmploymentTypeEnum!
  employmentPercentage: Decimal
  employmentPercentageUpdated: Date
  hoursEveryWeekWithFullEmployment: Decimal
  lastSalaryChange: Date
  durationType: AltinnEmploymentDurationTypeEnum
}

type AmeldingFeedbackDeviation {
  details: String
  deviationId: String
  incomeReceiverName: String
  incomeReceiverSsn: String
  month: String
  name: String
  severity: String
  subUnitName: String
  subUnitOrgno: String
}

type AmeldingPensionAmount {
  amount: Decimal!
  employerTaxZone: EmployerTaxZone!
  id: ID!
  subUnit: SubUnit!
}

type AmeldingReconciliationReport {
  altinn3Submission: Altinn3Submission
  altinnSubmission: AltinnSubmission
  ameldingReconciliationReference: String
  ameldingReconciliationReportData: AmeldingReconciliationReportData
  calendarMonth: String!
  id: ID!
  unit: Unit!
}

type AmeldingReconciliationReportData {
  calendarMonth: String!
  createdBy: User!
  employerTax: Decimal!
  id: ID!
  pension: Decimal!
  reimbursement: Decimal!
  salary: Decimal!
  statusAt: DateTime!
  taxDeduction: Decimal!
  unit: Unit!
}

input AmeldingReconciliationReportUploadInput {
  clientMutationId: String
  unitId: ID!
  files: [FileUpload!]!
}

type AmeldingReconciliationReportUploadPayload {
  clientMutationId: String
  reports: [AmeldingReconciliationReportData!]!
}

type AmeldingReimbursement {
  amount: Decimal!
  employerTaxZone: EmployerTaxZone!
  id: ID!
  subUnit: SubUnit!
}

type AmeldingWorkRelation {
  amelding: Amelding!
  ameldingWorkRelationLeaveAndLayoffs: [AmeldingWorkRelationLeaveAndLayoff!]!
  durationType: AltinnEmploymentDurationTypeEnum
  employee: Employee!
  employmentPercentage: Decimal
  employmentPercentageUpdated: Date
  employmentType: AltinnEmploymentTypeEnum!
  endDate: Date
  endDateSentToAltinn: Boolean!
  endReason: AltinnEmploymentEndReasonEnum
  hoursEveryWeekWithFullEmployment: Decimal
  id: ID!
  lastSalaryChange: Date
  occupation: Occupation
  samePositionSince: Date
  shiftType: AltinnShiftTypeEnum
  startDate: Date
  subUnit: SubUnit!
  workRelation: WorkRelation!
}

type AmeldingWorkRelationLeaveAndLayoff {
  ameldingWorkRelations: [AmeldingWorkRelation!]!
  id: ID!
  workRelationLeaveAndLayoff: WorkRelationLeaveAndLayoff!
}

type AppSettings {
  altinnPensionUnits: [Unit!]!
}

input AppSettingsSave {
  altinnPensionUnitIds: [ID!]
}

input AppSettingsSaveInput {
  clientMutationId: String
  appSettings: AppSettingsSave!
}

type AppSettingsSavePayload {
  appSettings: AppSettings!

  clientMutationId: String
}

type Attachment {
  content: String
  contentType: String
  fileName: String
  id: ID
  signedBlobId: String
  size: Int!
  url(size: AttachmentSizeEnum = null): String
}

enum AttachmentSizeEnum {
  ICON
  SMALL
  MEDIUM
  LARGE
  REAL
}

type Car {
  id: ID!
  name: String!
  norwegianListPriceAsNew: Decimal
  registrationNumber: String!
  unit: Unit!
}

input CarCreate {
  registrationNumber: String!
  norwegianListPriceAsNew: Decimal
  name: String!
  unitId: ID!
}

input CarCreateInput {
  clientMutationId: String
  car: CarCreate!
}

type CarCreatePayload {
  car: Car

  clientMutationId: String
}

input CarDeleteInput {
  clientMutationId: String
  id: ID!
}

type CarDeletePayload {
  car: Car

  clientMutationId: String
}

enum CarFuelEnum {
  DIESEL
  GASOLINE
  ELECTRONIC
}

enum CarTypeEnum {
  PERSONAL
  VAN
  TRACTOR
  TRUCK
  TRUCK_TRAILER
  SCOOTER
  BIKE
  TRAILER
}

input CarUpdate {
  registrationNumber: String
  norwegianListPriceAsNew: Decimal
  name: String
  id: ID!
}

input CarUpdateInput {
  clientMutationId: String
  car: CarUpdate!
}

type CarUpdatePayload {
  car: Car

  clientMutationId: String
}

enum CompanyNameOptionEnum {
  NAME
  ALIAS
}

type Country {
  code: String!
  currency: Currency
  currencyCode: String
  name: String!
  phoneCode: String
}

input CreateNextOrderFromRecurringOrderInput {
  clientMutationId: String
  recurringOrderId: ID!
}

type CreateNextOrderFromRecurringOrderPayload {
  clientMutationId: String
  order: Order
  recurringOrder: RecurringOrder
}

type Currency {
  code: String!
  name: String!
}

type Customer {
  autoSendInvoice: Boolean!
  creditDays: Int!
  customEmail: String
  customPhone: String
  customerContacts: [CustomerContact!]!
  customerNumber: String
  deliveryLocations: [DeliveryLocation!]!
  efakturaEligible: Boolean!
  efakturaIdentifier: String
  email: String
  id: ID!
  invoiceDeliveryMethod: InvoiceDeliveryMethodEnum!
  owner: Unit!
  phone: String
  reference: String
  unit: Unit!
  unofficialName: String
}

type CustomerContact {
  comment: String
  customer: Customer!
  email: String
  firstName: String!
  id: ID!
  jobTitle: String
  lastName: String!
  phone: String
}

input CustomerContactCreate {
  firstName: String!
  lastName: String!
  phone: String
  email: String
  jobTitle: String
  comment: String
}

input CustomerContactUpdate {
  firstName: String
  lastName: String
  phone: String
  email: String
  jobTitle: String
  comment: String
  id: ID
  _destroy: Boolean
}

input CustomerCreate {
  unitId: ID!
  deliveryLocations: [DeliveryLocationSave!]
  creditDays: Int!
  reference: String
  customPhone: String
  customEmail: String
  invoiceDeliveryMethod: InvoiceDeliveryMethodEnum!
  autoSendInvoice: Boolean
  unofficialName: String
  customerNumber: String
  ownerId: ID!
  customerContacts: [CustomerContactCreate!]
}

input CustomerCreateInput {
  clientMutationId: String
  customer: CustomerCreate!
}

type CustomerCreatePayload {
  clientMutationId: String
  customer: Customer
}

input CustomerDeleteInput {
  clientMutationId: String
  id: ID!
}

type CustomerDeletePayload {
  clientMutationId: String
  customer: Customer
}

input CustomerFilter {
  unitId: ID
  unitName: String
  deliveryAddress: String
  deliveryCity: String
  deliveryZip: String
  deliveryCountryName: String
  creditDays: Int
  reference: String
  unofficialName: String
  unitActiveAt: String
  nameWithAlias: String
}

input CustomerUpdate {
  unitId: ID
  deliveryLocations: [DeliveryLocationSave!]
  creditDays: Int
  reference: String
  customPhone: String
  customEmail: String
  invoiceDeliveryMethod: InvoiceDeliveryMethodEnum
  autoSendInvoice: Boolean
  unofficialName: String
  customerNumber: String
  id: ID!
  customerContacts: [CustomerContactUpdate!]
}

input CustomerUpdateInput {
  clientMutationId: String
  customer: CustomerUpdate!
}

type CustomerUpdatePayload {
  clientMutationId: String
  customer: Customer
}

scalar Date

scalar DateTime

scalar Decimal

type DeliveryLocation {
  additionalAddress: String
  address: String!
  city: String!
  country: Country!
  id: ID!
  zip: String!
}

input DeliveryLocationSave {
  id: String
  address: String
  additionalAddress: String
  zip: String
  city: String
  countryCode: String
  _destroy: Boolean
}

type Department {
  code: String!
  id: ID!
  name: String!
  unit: Unit!
}

input DepartmentCreate {
  code: String!
  name: String!
  unitId: ID!
}

input DepartmentCreateInput {
  clientMutationId: String
  department: DepartmentCreate!
}

type DepartmentCreatePayload {
  clientMutationId: String
  department: Department
}

input DepartmentDeleteInput {
  clientMutationId: String
  id: ID!
}

type DepartmentDeletePayload {
  clientMutationId: String
  department: Department
}

input DepartmentUpdate {
  code: String
  name: String
  id: ID!
}

input DepartmentUpdateInput {
  clientMutationId: String
  department: DepartmentUpdate!
}

type DepartmentUpdatePayload {
  clientMutationId: String
  department: Department
}

input EfakturaCreateIssuerInput {
  name: String!
  organizationNumber: String!
  billingAccountNumber: String!
  emailAddress: String!
  postalCode: String!
  postalCity: String!
  countryCode: String!
}

input EfakturaHealthCheckInput {
  clientMutationId: String
}

type EfakturaHealthCheckPayload {
  clientMutationId: String
  response: Json
}

type EfakturaIssuer {
  billingAccountNumber: String!
  countryCode: String!
  emailAddress: String!
  id: ID!
  name: String!
  organizationNumber: String!
  postalCity: String!
  postalCode: String!
  status: String
  unit: Unit!
}

input EfakturaIssuerCreateInput {
  clientMutationId: String
  unitId: ID!
  input: EfakturaCreateIssuerInput!
}

type EfakturaIssuerCreatePayload {
  clientMutationId: String
  efakturaIssuer: EfakturaIssuer
  response: Json
}

input EfakturaShipmentAddInput {
  clientMutationId: String
  shipment: EfakturaShipmentInput!
}

type EfakturaShipmentAddPayload {
  clientMutationId: String
  efakturaSubmission: EfakturaSubmission
}

input EfakturaShipmentInput {
  invoiceId: ID!
  efakturaIdentifier: String!
}

input EfakturaShipmentsGetInput {
  clientMutationId: String
  unitId: ID!
  from: DateTime!
  to: DateTime!
}

type EfakturaShipmentsGetPayload {
  clientMutationId: String
  response: Json
}

input EfakturaShipmentStatusGetInput {
  clientMutationId: String
  unitId: ID!
  shipmentId: String!
}

type EfakturaShipmentStatusGetPayload {
  clientMutationId: String
  response: Json
}

type EfakturaSubmission {
  efakturaIdentifier: String
  errorMessage: String
  humanStatus: String!
  id: ID!
  invoiceNumber: String
  issuerOrgNumber: String!
  messageIdentifier: String
  parentId: ID!
  parentType: String!
  pending: Boolean!
  sendingStatus: String!
  sentAt: DateTime!
  sentBy: User!
  shipmentId: String!
  shipmentStatus: String
  transactionId: String!
  transactionStatus: String
  unit: Unit!
}

input EfakturaTransactionStatusGetInput {
  clientMutationId: String
  unitId: ID!
  transactionId: String!
}

type EfakturaTransactionStatusGetPayload {
  clientMutationId: String
  response: Json
}

type Employee {
  address: String!
  bban: String
  birthDate: Date!
  birthDateMismatchReason: String
  city: String!
  country: Country!
  creditDays: Int!
  employeeTaxCards: [EmployeeTaxCard!]!
  firstName: String!
  iban: String
  id: ID!
  lastName: String!
  phone: String
  phoneCountry: Country
  postboxCity: String
  postboxNumber: String
  postboxPlace: String
  postboxZip: String
  socialSecurityNumber: String
  swift: String
  temporarySocialSecurityNumber: String
  unit: Unit!
  user: User!
  vacationMoneyPercentage: Decimal!
  workRelations: [WorkRelation!]!
  zip: String!
}

input EmployeeCreate {
  firstName: String!
  lastName: String!
  address: String!
  zip: String!
  city: String!
  phone: String
  phoneCountryCode: String
  countryCode: String!
  postboxNumber: String
  postboxPlace: String
  postboxZip: String
  postboxCity: String
  birthDateMismatchReason: String
  birthDate: Date!
  bban: String
  iban: String
  swift: String
  vacationMoneyPercentage: Decimal!
  socialSecurityNumber: String
  temporarySocialSecurityNumber: String
  creditDays: Int!
  unitId: ID!
  user: UserEmployee!
}

input EmployeeCreateInput {
  clientMutationId: String
  employee: EmployeeCreate!
}

type EmployeeCreatePayload {
  clientMutationId: String
  employee: Employee
}

input EmployeeDeleteInput {
  clientMutationId: String
  id: ID!
}

type EmployeeDeletePayload {
  clientMutationId: String
  employee: Employee
}

type EmployeeSearch {
  emailMatch: Boolean!
  phoneMatch: Boolean!
  ssnMatch: Boolean!
  tssnMatch: Boolean!
  unit: Unit
}

type EmployeeTaxCard {
  calendarYear: Int
  employee: Employee!
  fetchedAt: Date!
  file: Attachment!
  id: ID!
  taxDeductionMethod: PaycheckTaxDeductionMethodEnum
  taxExemption: Boolean!
  taxExemptionAmountLimit: Decimal
  taxPercentage: Decimal
  taxTable: String
}

input EmployeeTaxCardEmployeeSave {
  fetchedAt: Date
  taxTable: String
  taxPercentage: Decimal
  taxExemption: Boolean
  file: FileUpload
  calendarYear: Int
  taxExemptionAmountLimit: Decimal
  taxDeductionMethod: PaycheckTaxDeductionMethodEnum
  id: ID
  _destroy: Boolean
}

input EmployeeUpdate {
  firstName: String
  lastName: String
  address: String
  zip: String
  city: String
  phone: String
  phoneCountryCode: String
  countryCode: String
  postboxNumber: String
  postboxPlace: String
  postboxZip: String
  postboxCity: String
  birthDateMismatchReason: String
  birthDate: Date
  bban: String
  iban: String
  swift: String
  vacationMoneyPercentage: Decimal
  socialSecurityNumber: String
  temporarySocialSecurityNumber: String
  creditDays: Int
  id: ID!
  employeeTaxCards: [EmployeeTaxCardEmployeeSave!]
  workRelations: [WorkRelationEmployeeSave!]
}

input EmployeeUpdateInput {
  clientMutationId: String
  employee: EmployeeUpdate!
}

type EmployeeUpdatePayload {
  clientMutationId: String
  employee: Employee
}

type EmployerTaxZone {
  code: String!
  id: ID!
  rate: Decimal!
}

input ExistingAttachmentInput {
  id: ID
  signedBlobId: String
  fileName: String
  url: String
}

scalar FileUpload

input GenerateRecurringOrdersForDateInput {
  clientMutationId: String
  date: Date!
}

type GenerateRecurringOrdersForDatePayload {
  clientMutationId: String
  orders: [Order!]!
}

type GovernmentCar {
  brand: String!
  fuel: CarFuelEnum
  modelyear: Int!
  registration: String!
  seats: Int
  type: CarTypeEnum!
}

type Identificator {
  country: Country
  description: String
  id: ID!
  name: String!
  priority: Int!
}

type Identity {
  id: ID!
  identificator: Identificator!
  unit: Unit!
  validFrom: Date!
  validTo: Date!
  value: String!
}

input IdentityCreate {
  identificatorId: ID!
  value: String!
  phoneCode: String
  countryCode: String
}

type Invoice {
  attachments: [Attachment!]!
  bban: String
  createdAt: DateTime!
  createdBy: User!
  currency: Currency!
  currencyCode: String!
  customNote: String
  customer: Customer!
  customerParty: OrderParty!
  dueDate: Date!
  emailLogs: [LogInvoiceMail!]!
  iban: String
  id: ID
  interestChargePreview: InvoiceInterestChargePreview
  interestNote: String
  invoiceInterestCharges: [InvoiceInterestCharge!]!
  invoiceOverdueNotices: [InvoiceOverdueNotice!]!
  invoicePaymentMethods: [InvoicePaymentMethod!]!
  isDeliveredToFb: Boolean!
  isInterestInvoice: Boolean!
  issueDate: Date!
  kid: String
  latestEfakturaSubmission: EfakturaSubmission
  latestMailLog: LogInvoiceMail
  legalNotes: [String!]!
  lineExtensionAmount: Decimal!
  note: String
  number: Int
  orderDelivery: OrderDelivery!
  orders: [Order!]!
  paidDate: Date
  payableAmount: Decimal!
  payableRoundingAmount: Decimal!
  paymentTerm: String
  pdf: Attachment!
  reference: String
  supplierParty: OrderParty!
  taxAmount: Decimal!
  taxExclusiveAmount: Decimal!
  taxInclusiveAmount: Decimal!
  unit: Unit!
}

type InvoiceChangedPayload {
  invoice: Invoice!
}

input InvoiceCreate {
  orderIds: [ID!]!
  issueDate: Date!
  dueDate: Date!
  paymentTerm: String
  supplierPartyId: ID
  customerPartyId: ID
  orderDeliveryId: ID
  invoicePaymentMethods: [InvoicePaymentMethodCreate!]!
  payableRoundingAmount: Decimal!
  payableAmount: Decimal!
  legalNotes: [String!]
  customNote: String
  attachments: [FileUpload!]
}

input InvoiceCreateInput {
  clientMutationId: String
  invoice: InvoiceCreate!
}

input InvoiceCreateInterestChargeInput {
  clientMutationId: String
  invoiceId: ID!
}

type InvoiceCreateInterestChargePayload {
  clientMutationId: String
  invoiceInterestCharge: InvoiceInterestCharge
}

input InvoiceCreateOverdueNoticeInput {
  clientMutationId: String
  invoiceId: ID!
  issueDate: Date!
  dueDate: Date!
  additionalCharge: Decimal!
}

type InvoiceCreateOverdueNoticePayload {
  clientMutationId: String
  invoiceOverdueNotice: InvoiceOverdueNotice
}

type InvoiceCreatePayload {
  clientMutationId: String
  invoice: Invoice
}

input InvoiceCreditNoteInput {
  clientMutationId: String
  invoiceId: ID!
}

type InvoiceCreditNotePayload {
  clientMutationId: String
  orders: [Order!]!
}

enum InvoiceDeliveryMethodEnum {
  email
  mail
  ehf
  manual
}

input InvoiceDuplicateInput {
  clientMutationId: String
  invoiceId: ID!
}

type InvoiceDuplicatePayload {
  clientMutationId: String
  orders: [Order!]!
}

input InvoiceEmailInput {
  clientMutationId: String
  invoiceId: ID!
  recipients: [String!]!
  shouldSendAttachments: Boolean!
}

type InvoiceEmailPayload {
  clientMutationId: String
  logInvoiceMail: [LogInvoiceMail!]!
}

input InvoiceFailedDeliveryDismissInput {
  clientMutationId: String
  logInvoiceMailId: ID!
}

type InvoiceFailedDeliveryDismissPayload {
  clientMutationId: String
  logInvoiceMail: LogInvoiceMail!
}

input InvoiceFilter {
  customerId: ID
  number: String
  customerName: String
  issueDate: String
  dueDate: String
  currency: String
  payableAmount: String
  note: String
}

type InvoiceInterestCharge {
  collectionFeeAmount: Decimal!
  days: Int!
  fromDate: Date!
  id: ID!
  interestAmount: Decimal!
  interestInvoice: Invoice!
  principalAmount: Decimal!
  rateSegments: [LatePaymentInterestSegment!]!
  toDate: Date!
  totalAmount: Decimal!
}

type InvoiceInterestChargePreview {
  availableFrom: Date!
  blockedReason: String
  chargeable: Boolean!
  collectionFeeAmount: Decimal!
  days: Int!
  fromDate: Date!
  interestAmount: Decimal!
  principalAmount: Decimal!
  segments: [LatePaymentInterestSegment!]!
  toDate: Date!
  totalAmount: Decimal!
}

input InvoiceMailLogCreateInput {
  clientMutationId: String
  invoiceId: ID!
  destination: String!
  deliveryMethod: InvoiceDeliveryMethodEnum!
  sentAt: DateTime!
}

type InvoiceMailLogCreatePayload {
  clientMutationId: String
  logInvoiceMail: LogInvoiceMail!
}

type InvoiceOverdueNotice {
  additionalCharge: Decimal
  dueDate: Date!
  id: ID!
  issueDate: Date!
  orderNumber: Int!
  overdueNoticeLogs: [LogInvoiceOverdueNoticeMail!]!
  pdf: Attachment!
}

input InvoiceOverdueNoticeEmailInput {
  clientMutationId: String
  invoiceOverdueNoticeId: ID!
  recipients: [String!]!
}

type InvoiceOverdueNoticeEmailPayload {
  clientMutationId: String
  logInvoiceOverdueNoticeMail: [LogInvoiceOverdueNoticeMail!]!
}

type InvoicePaymentMethod {
  amount: Decimal!
  id: ID!
  name: String!
}

input InvoicePaymentMethodCreate {
  name: String!
  amount: Decimal!
}

input InvoiceSendByEfakturaInput {
  clientMutationId: String
  invoiceId: ID!
}

type InvoiceSendByEfakturaPayload {
  clientMutationId: String
  efakturaSubmission: EfakturaSubmission
}

input InvoiceSendByEHFInput {
  clientMutationId: String
  invoiceId: ID!
}

type InvoiceSendByEHFPayload {
  clientMutationId: String
  logInvoiceMail: LogInvoiceMail!
}

scalar Json

type LatePaymentInterestSegment {
  amount: Decimal!
  days: Int!
  fromDate: Date!
  rate: Decimal!
  toDate: Date!
}

type LogInvoiceMail {
  attachmentsCount: Int!
  deliveryError: String
  deliveryMethod: InvoiceDeliveryMethodEnum!
  deliveryStatus: String!
  destination: String!
  id: ID!
  invoice: Invoice!
  sentAt: DateTime!
  sentBy: User!
}

type LogInvoiceOverdueNoticeMail {
  deliveryError: String
  deliveryStatus: String!
  id: ID!
  invoiceOverdueNotice: InvoiceOverdueNotice!
  recipientMail: String!
  sentAt: DateTime!
  sentBy: User!
}

type LogOrderMail {
  deliveryError: String
  deliveryStatus: String!
  id: ID!
  order: Order!
  pdfType: OrderPDFTypeEnum!
  recipientMail: String!
  sentAt: DateTime!
  sentBy: User!
}

type MainPaycheckLineTemplate {
  active: Boolean!
  altinnDescription: AltinnIncomeDescriptionEnum
  altinnFordel: AltinnFordelEnum
  calculatePositive: Boolean!
  calculationType: PaycheckLineCalculationTypeEnum!
  car: Car
  carOverwrite: Boolean!
  department: Department
  departmentOverwrite: Boolean!
  description: String!
  editableFromEmployeePage: Boolean!
  employerTaxable: Boolean!
  garnishment: Boolean!
  garnishmentSamordnet: Boolean!
  id: ID!
  includeInVacationMoneyBase: Boolean!
  number: Int!
  project: Project
  projectOverwrite: Boolean!
  quantity: Decimal!
  rate: Decimal!
  sum: Decimal!
  taxDeduction: Boolean!
  taxDeductionVoluntary: Boolean!
  taxable: Boolean!
  unit: Unit
  vacationMoneyEarnedInCurrentYear: Boolean!
  vacationMoneyEarnedInPreviousYear: Boolean!
}

input MainPaycheckLineTemplateImportToUnitInput {
  clientMutationId: String
  unitId: ID!
}

type MainPaycheckLineTemplateImportToUnitPayload {
  clientMutationId: String
  mainPaycheckLineTemplates: [MainPaycheckLineTemplate!]
}

input MainPaycheckLineTemplateSave {
  id: ID
  number: Int
  active: Boolean
  description: String
  altinnDescription: AltinnIncomeDescriptionEnum
  altinnFordel: AltinnFordelEnum
  calculationType: PaycheckLineCalculationTypeEnum
  calculatePositive: Boolean
  quantity: Decimal
  rate: Decimal
  sum: Decimal
  carId: ID
  projectId: ID
  departmentId: ID
  carOverwrite: Boolean
  projectOverwrite: Boolean
  departmentOverwrite: Boolean
  taxable: Boolean
  employerTaxable: Boolean
  includeInVacationMoneyBase: Boolean
  taxDeduction: Boolean
  taxDeductionVoluntary: Boolean
  garnishment: Boolean
  garnishmentSamordnet: Boolean
  editableFromEmployeePage: Boolean
  vacationMoneyEarnedInPreviousYear: Boolean
  vacationMoneyEarnedInCurrentYear: Boolean
}

input MainPaycheckLineTemplateSaveInput {
  clientMutationId: String
  mainPaycheckLineTemplates: [MainPaycheckLineTemplateSave!]!
  unitId: ID
}

type MainPaycheckLineTemplateSavePayload {
  clientMutationId: String
  mainPaycheckLineTemplates: [MainPaycheckLineTemplate!]
}

type Municipality {
  address1: String
  address2: String
  address3: String
  bban: String!
  city: String
  comment: String
  countyName: String!
  email: String
  employerTaxZone: EmployerTaxZone!
  id: ID!
  mobile: String
  name: String!
  number: String!
  organizationForm: String
  organizationName: String!
  organizationNumber: String!
  telefax: String
  telephone: String
  webpage: String
  zip: String
}

type MunicipalitySelection {
  createdBy: User!
  id: ID!
  municipality: Municipality!
  unit: Unit!
}

input MunicipalitySelectionCreateInput {
  clientMutationId: String
  municipalityId: ID!
  unitId: ID!
}

type MunicipalitySelectionCreatePayload {
  clientMutationId: String
  municipalitySelection: MunicipalitySelection
}

input MunicipalitySelectionDeleteInput {
  clientMutationId: String
  id: ID!
}

type MunicipalitySelectionDeletePayload {
  clientMutationId: String
  municipalitySelection: MunicipalitySelection
}

type Mutation {
  addEfakturaShipment(
    input: EfakturaShipmentAddInput!
  ): EfakturaShipmentAddPayload
  cancelAltinn3Amelding(
    input: Altinn3AmeldingCancelInput!
  ): Altinn3AmeldingCancelPayload
  cancelOrder(
    input: OrderCancelInput!
  ): OrderCancelPayload
  checkAltinn3SubmissionStatus(
    input: Altinn3SubmissionCheckStatusInput!
  ): Altinn3SubmissionCheckStatusPayload
  checkEfakturaShipmentStatus(
    input: EfakturaShipmentStatusGetInput!
  ): EfakturaShipmentStatusGetPayload
  checkEfakturaTransactionStatus(
    input: EfakturaTransactionStatusGetInput!
  ): EfakturaTransactionStatusGetPayload
  createCar(
    input: CarCreateInput!
  ): CarCreatePayload
  createCreditNote(
    input: InvoiceCreditNoteInput!
  ): InvoiceCreditNotePayload
  createCustomer(
    input: CustomerCreateInput!
  ): CustomerCreatePayload
  createDepartment(
    input: DepartmentCreateInput!
  ): DepartmentCreatePayload
  createEfakturaIssuer(
    input: EfakturaIssuerCreateInput!
  ): EfakturaIssuerCreatePayload
  createEmployee(
    input: EmployeeCreateInput!
  ): EmployeeCreatePayload
  createInvoice(
    input: InvoiceCreateInput!
  ): InvoiceCreatePayload
  createInvoiceInterestCharge(
    input: InvoiceCreateInterestChargeInput!
  ): InvoiceCreateInterestChargePayload
  createInvoiceMailLog(
    input: InvoiceMailLogCreateInput!
  ): InvoiceMailLogCreatePayload
  createInvoiceOverdueNotice(
    input: InvoiceCreateOverdueNoticeInput!
  ): InvoiceCreateOverdueNoticePayload
  createMunicipalitySelection(
    input: MunicipalitySelectionCreateInput!
  ): MunicipalitySelectionCreatePayload
  createNextOrderFromRecurringOrder(
    input: CreateNextOrderFromRecurringOrderInput!
  ): CreateNextOrderFromRecurringOrderPayload
  createOccupationSelection(
    input: OccupationSelectionCreateInput!
  ): OccupationSelectionCreatePayload
  createOrder(
    input: OrderCreateInput!
  ): OrderCreatePayload
  createPaycheck(
    input: PaycheckCreateInput!
  ): PaycheckCreatePayload
  createPaymentMethod(
    input: PaymentMethodCreateInput!
  ): PaymentMethodCreatePayload
  createPensionUnitSelection(
    input: PensionUnitSelectionCreateInput!
  ): PensionUnitSelectionCreatePayload
  createProduct(
    input: ProductCreateInput!
  ): ProductCreatePayload
  createProductGroup(
    input: ProductGroupCreateInput!
  ): ProductGroupCreatePayload
  createProductVariantHolder(
    input: ProductVariantHolderCreateInput!
  ): ProductVariantHolderCreatePayload
  createProject(
    input: ProjectCreateInput!
  ): ProjectCreatePayload
  createRecurringOrder(
    input: RecurringOrderCreateInput!
  ): RecurringOrderCreatePayload
  createSubUnit(
    input: SubUnitCreateInput!
  ): SubUnitCreatePayload
  createUnit(
    input: UnitCreateInput!
  ): UnitCreatePayload
  createWarehousePatch(
    input: WarehousePatchCreateInput!
  ): WarehousePatchCreatePayload
  createWebstoreApiToken(
    input: WebstoreApiTokenCreateInput!
  ): WebstoreApiTokenCreatePayload
  deleteCar(
    input: CarDeleteInput!
  ): CarDeletePayload
  deleteCustomer(
    input: CustomerDeleteInput!
  ): CustomerDeletePayload
  deleteDepartment(
    input: DepartmentDeleteInput!
  ): DepartmentDeletePayload
  deleteEmployee(
    input: EmployeeDeleteInput!
  ): EmployeeDeletePayload
  deleteMunicipalitySelection(
    input: MunicipalitySelectionDeleteInput!
  ): MunicipalitySelectionDeletePayload
  deleteOccupationSelection(
    input: OccupationSelectionDeleteInput!
  ): OccupationSelectionDeletePayload
  deletePaymentMethod(
    input: PaymentMethodDeleteInput!
  ): PaymentMethodDeletePayload
  deleteProduct(
    input: ProductDeleteInput!
  ): ProductDeletePayload
  deleteProductGroup(
    input: ProductGroupDeleteInput!
  ): ProductGroupDeletePayload
  deleteProductVariantHolder(
    input: ProductVariantHolderDeleteInput!
  ): ProductVariantHolderDeletePayload
  deleteProject(
    input: ProjectDeleteInput!
  ): ProjectDeletePayload
  deleteSubUnit(
    input: SubUnitDeleteInput!
  ): SubUnitDeletePayload
  deleteWebstoreApiToken(
    input: WebstoreApiTokenDeleteInput!
  ): WebstoreApiTokenDeletePayload
  dismissFailedInvoiceDelivery(
    input: InvoiceFailedDeliveryDismissInput!
  ): InvoiceFailedDeliveryDismissPayload
  duplicateInvoice(
    input: InvoiceDuplicateInput!
  ): InvoiceDuplicatePayload
  duplicateOrder(
    input: OrderDuplicateInput!
  ): OrderDuplicatePayload
  efakturaHealthCheck(
    input: EfakturaHealthCheckInput!
  ): EfakturaHealthCheckPayload
  emailInvoice(
    input: InvoiceEmailInput!
  ): InvoiceEmailPayload
  emailInvoiceOverdueNotice(
    input: InvoiceOverdueNoticeEmailInput!
  ): InvoiceOverdueNoticeEmailPayload
  emailOrder(
    input: OrderEmailInput!
  ): OrderEmailPayload
  emailVacationMoneySummary(
    input: VacationMoneySummaryEmailInput!
  ): VacationMoneySummaryEmailPayload
  fetchPaycheckLinesFromTemplate(
    input: PaycheckFetchLinesFromTemplateInput!
  ): PaycheckFetchLinesFromTemplatePayload
  fetchWorkRelationInfoPaycheck(
    input: PaycheckFetchWorkRelationInfoInput!
  ): PaycheckFetchWorkRelationInfoPayload
  generateRecurringOrdersForDate(
    input: GenerateRecurringOrdersForDateInput!
  ): GenerateRecurringOrdersForDatePayload
  getAltinn3SubmissionFeedback(
    input: Altinn3SubmissionFeedbackGetInput!
  ): Altinn3SubmissionFeedbackGetPayload
  getEfakturaShipments(
    input: EfakturaShipmentsGetInput!
  ): EfakturaShipmentsGetPayload
  importMainPaycheckLineTemplateToUnit(
    input: MainPaycheckLineTemplateImportToUnitInput!
  ): MainPaycheckLineTemplateImportToUnitPayload
  lockOrder(
    input: OrderLockInput!
  ): OrderLockPayload
  lockPaycheck(
    input: PaycheckLockInput!
  ): PaycheckLockPayload
  refreshAltinn3SystemUserStatus(
    input: Altinn3SystemUserRefreshStatusInput!
  ): Altinn3SystemUserRefreshStatusPayload
  registerAltinn3SystemUser(
    input: Altinn3SystemUserRegisterInput!
  ): Altinn3SystemUserRegisterPayload
  requestAccessToUnit(
    input: RequestAccessToUnitInput!
  ): RequestAccessToUnitPayload
  revertPaycheck(
    input: PaycheckRevertInput!
  ): PaycheckRevertPayload
  saveAmeldingAccountSelections(
    input: AmeldingAccountSelectionsSaveInput!
  ): AmeldingAccountSelectionsSavePayload
  saveAppSettings(
    input: AppSettingsSaveInput!
  ): AppSettingsSavePayload
  saveMainPaycheckLineTemplate(
    input: MainPaycheckLineTemplateSaveInput!
  ): MainPaycheckLineTemplateSavePayload
  savePaycheckDraft(
    input: PaycheckDraftSaveInput!
  ): PaycheckDraftSavePayload
  savePaycheckPeriod(
    input: PaycheckPeriodSaveInput!
  ): PaycheckPeriodSavePayload
  saveSettingsVacationMoneyReport(
    input: SettingsVacationMoneyReportSaveInput!
  ): SettingsVacationMoneyReportSavePayload
  saveUnitSetting(
    input: UnitSettingSaveInput!
  ): UnitSettingSavePayload
  saveWorkRelationTimesheet(
    input: WorkRelationTimesheetSaveInput!
  ): WorkRelationTimesheetSavePayload
  saveWorkRelationTimesheetComment(
    input: WorkRelationTimesheetCommentSaveInput!
  ): WorkRelationTimesheetCommentSavePayload
  sendAltinn3Amelding(
    input: Altinn3AmeldingSendInput!
  ): Altinn3AmeldingSendPayload
  sendAltinnTaxToFb(
    input: AltinnTaxSendToFbInput!
  ): AltinnTaxSendToFbPayload
  sendInvoiceByEfaktura(
    input: InvoiceSendByEfakturaInput!
  ): InvoiceSendByEfakturaPayload
  sendInvoiceByEhf(
    input: InvoiceSendByEHFInput!
  ): InvoiceSendByEHFPayload
  sendYearlyReportForEmployeeToFb(
    input: YearlyReportForEmployeeSendToFbInput!
  ): YearlyReportForEmployeeSendToFbPayload
  submitWorkRelationTimesheet(
    input: WorkRelationTimesheetSubmitInput!
  ): WorkRelationTimesheetSubmitPayload
  updateCar(
    input: CarUpdateInput!
  ): CarUpdatePayload
  updateCustomer(
    input: CustomerUpdateInput!
  ): CustomerUpdatePayload
  updateDepartment(
    input: DepartmentUpdateInput!
  ): DepartmentUpdatePayload
  updateEmployee(
    input: EmployeeUpdateInput!
  ): EmployeeUpdatePayload
  updateOrder(
    input: OrderUpdateInput!
  ): OrderUpdatePayload
  updatePaycheck(
    input: PaycheckUpdateInput!
  ): PaycheckUpdatePayload
  updatePaycheckLineTemplate(
    input: PaycheckLineTemplateUpdateInput!
  ): PaycheckLineTemplateUpdatePayload
  updatePaycheckPaidDate(
    input: PaycheckPaidDateUpdateInput!
  ): PaycheckPaidDateUpdatePayload
  updatePaymentMethod(
    input: PaymentMethodUpdateInput!
  ): PaymentMethodUpdatePayload
  updatePensionUnitSelection(
    input: PensionUnitSelectionUpdateInput!
  ): PensionUnitSelectionUpdatePayload
  updateProduct(
    input: ProductUpdateInput!
  ): ProductUpdatePayload
  updateProductGroup(
    input: ProductGroupUpdateInput!
  ): ProductGroupUpdatePayload
  updateProductVariantHolder(
    input: ProductVariantHolderUpdateInput!
  ): ProductVariantHolderUpdatePayload
  updateProject(
    input: ProjectUpdateInput!
  ): ProjectUpdatePayload
  updateRecurringOrder(
    input: RecurringOrderUpdateInput!
  ): RecurringOrderUpdatePayload
  updateSubUnit(
    input: SubUnitUpdateInput!
  ): SubUnitUpdatePayload
  updateWarehousePatch(
    input: WarehousePatchUpdateInput!
  ): WarehousePatchUpdatePayload
  uploadAmeldingReconciliationReport(
    input: AmeldingReconciliationReportUploadInput!
  ): AmeldingReconciliationReportUploadPayload
}

type NorwegianVatRate {
  endDate: Date
  rate: Decimal!
  startDate: Date
  symbol: NorwegianVatSymbolEnum!
}

enum NorwegianVatSymbolEnum {
  STANDARD
  REDUCED
  REDUCED_FISH
  LOW
  ZERO
  EXEMPT
}

type Occupation {
  code: String!
  createdAt: Date!
  id: ID!
  name: String!
  updatedAt: Date!
  validFrom: Date!
}

type OccupationSelection {
  createdAt: Date!
  createdBy: User!
  id: ID!
  occupation: Occupation!
  unit: Unit!
  updatedAt: Date!
}

input OccupationSelectionCreate {
  occupationId: ID!
  unitId: ID!
}

input OccupationSelectionCreateInput {
  clientMutationId: String
  occupationSelection: OccupationSelectionCreate!
}

type OccupationSelectionCreatePayload {
  clientMutationId: String
  occupationSelection: OccupationSelection
}

input OccupationSelectionDeleteInput {
  clientMutationId: String
  id: ID!
}

type OccupationSelectionDeletePayload {
  clientMutationId: String
  occupationSelection: OccupationSelection
}

type Order {
  accountingCost: String
  bban: String
  cancelledAt: DateTime
  cancelledBy: User
  car: Car
  createdBy: User!
  currency: Currency!
  currencyCode: String!
  customer: Customer!
  customerParty: OrderParty!
  date: Date!
  department: Department
  export: Boolean!
  iban: String
  id: ID!
  invoice: Invoice
  isCancelled: Boolean!
  isLocked: Boolean!
  isOpen: Boolean!
  lineExtensionAmount: Decimal!
  lockedAt: DateTime
  lockedBy: User
  logo: Attachment!
  note: String
  number: Int!
  offerMailLogs: [LogOrderMail!]!
  offerPdf: Attachment!
  orderAllowanceCharges: [OrderAllowanceCharge!]!
  orderConfirmationMailLogs: [LogOrderMail!]!
  orderConfirmationPdf: Attachment!
  orderDelivery: OrderDelivery!
  orderLines: [OrderLine!]!
  orderMailLogs: [LogOrderMail!]!
  orderPdf: Attachment!
  packingSlipMailLogs: [LogOrderMail!]!
  packingSlipPdf: Attachment!
  payableAmount: Decimal!
  project: Project
  reference: String
  savedAt: DateTime!
  savedBy: User
  status: OrderStatusEnum!
  supplierParty: OrderParty!
  taxAmount: Decimal!
  taxExclusiveAmount: Decimal!
  taxInclusiveAmount: Decimal!
  unit: Unit!
}

type OrderAllowanceCharge {
  id: ID!
  orderAllowanceChargeLines: [OrderAllowanceChargeLine!]!
  percent: Decimal!
  reason: String
}

input OrderAllowanceChargeBase {
  id: ID
  orderId: ID
  reason: String
  percent: Decimal
  orderAllowanceChargeLines: [OrderAllowanceChargeLineBase!]
}

type OrderAllowanceChargeLine {
  amount: Decimal!
  baseAmount: Decimal!
  id: ID!
  orderAllowanceCharge: OrderAllowanceCharge!
  taxPercent: Decimal!
  vatRateSymbol: NorwegianVatSymbolEnum!
}

input OrderAllowanceChargeLineBase {
  id: ID
  orderAllowanceChargeId: ID
  amount: Decimal
  baseAmount: Decimal
  vatRateSymbol: NorwegianVatSymbolEnum
  taxPercent: Decimal
  _destroy: Boolean
}

input OrderCancelInput {
  clientMutationId: String
  id: ID!
}

type OrderCancelPayload {
  clientMutationId: String
  order: Order
}

input OrderCreate {
  note: String
  currencyCode: String!
  supplierParty: OrderPartyBase!
  customerParty: OrderPartyBase!
  orderDelivery: OrderDeliveryBase!
  bban: String
  iban: String
  reference: String
  export: Boolean
  taxAmount: Decimal!
  lineExtensionAmount: Decimal!
  taxExclusiveAmount: Decimal!
  taxInclusiveAmount: Decimal!
  payableAmount: Decimal!
  unitId: ID!
  customerId: ID!
  carId: ID
  projectId: ID
  departmentId: ID
  logo: ExistingAttachmentInput
  orderLines: [OrderLineBase!]
  orderAllowanceCharges: [OrderAllowanceChargeBase!]
  date: Date!
}

input OrderCreateInput {
  clientMutationId: String
  order: OrderCreate!
}

type OrderCreatePayload {
  clientMutationId: String
  order: Order
}

type OrderDelivery {
  additionalStreetName: String
  city: String!
  country: Country!
  countryCode: String!
  date: Date!
  id: ID!
  streetName: String!
  zip: String!
}

input OrderDeliveryBase {
  id: ID
  date: Date
  streetName: String
  additionalStreetName: String
  city: String
  zip: String
  countryCode: String
}

input OrderDuplicateInput {
  clientMutationId: String
  orderId: ID!
}

type OrderDuplicatePayload {
  clientMutationId: String
  order: Order
}

input OrderEmailInput {
  clientMutationId: String
  orderId: ID!
  pdfType: OrderPDFTypeEnum!
  recipients: [String!]!
}

type OrderEmailPayload {
  clientMutationId: String
  logOrderMails: [LogOrderMail!]!
}

input OrderFilter {
  number: String
  customerName: String
  date: String
  payableAmount: String
  status: OrderStatusEnum
  currency: String
  note: String
}

type OrderInvoiceStartNumberSet {
  invoiceNumberSet: Boolean!
  orderNumberSet: Boolean!
}

type OrderLine {
  accountingCost: String
  car: Car
  department: Department
  id: ID!
  itemDescription: String
  itemName: String!
  lineExtensionAmount: Decimal!
  note: String
  number: Int!
  orderLineAllowanceCharge: OrderLineAllowanceCharge
  orderedQuantity: Decimal!
  priceAmount: Decimal!
  product: Product!
  productDescription: String
  productDescriptionEnabled: Boolean!
  project: Project
  quantity: Decimal!
  sellersItemIdentificationId: String!
  taxAmount: Decimal!
  taxExemptionReason: String
  taxPercent: Decimal!
  unitOfMeasureCode: String!
  vatRateSymbol: NorwegianVatSymbolEnum!
}

type OrderLineAllowanceCharge {
  amount: Decimal!
  id: ID!
  orderLine: OrderLine!
  percent: Decimal!
  reason: String
}

input OrderLineAllowanceChargeBase {
  id: ID
  orderLineId: ID
  reason: String
  percent: Decimal
  amount: Decimal
}

input OrderLineBase {
  id: ID
  orderId: ID
  number: Int
  note: String
  orderedQuantity: Decimal
  quantity: Decimal
  unitOfMeasureCode: String
  lineExtensionAmount: Decimal
  taxAmount: Decimal
  productId: ID
  productDescription: String
  productDescriptionEnabled: Boolean
  itemName: String
  itemDescription: String
  sellersItemIdentificationId: String
  vatRateSymbol: NorwegianVatSymbolEnum
  taxPercent: Decimal
  taxExemptionReason: String
  priceAmount: Decimal
  carId: ID
  projectId: ID
  departmentId: ID
  orderLineAllowanceCharge: OrderLineAllowanceChargeBase
  _destroy: Boolean
}

input OrderLockInput {
  clientMutationId: String
  id: ID!
  createOrderFromDifference: Boolean = false
}

type OrderLockPayload {
  clientMutationId: String
  order: Order
}

type OrderParty {
  additionalStreetName: String
  city: String!
  country: Country!
  countryCode: String!
  email: String
  foretaksRegisteredSince: Date
  id: ID!
  mobile: String
  name: String!
  partyIdentification: String!
  partyIdentificationScheme: String!
  phone: String
  reference: String
  streetName: String
  unofficialName: String
  vatRegulation: Boolean!
  zip: String!
}

input OrderPartyBase {
  id: ID
  partyIdentificationScheme: String
  partyIdentification: String
  name: String
  unofficialName: String
  phone: String
  mobile: String
  email: String
  streetName: String
  additionalStreetName: String
  city: String
  zip: String
  countryCode: String
  reference: String
  vatRegulation: Boolean
  foretaksRegisteredSince: Date
}

enum OrderPDFTypeEnum {
  offer
  order
  orderConfirmation
  packingSlip
}

enum OrderStatusEnum {
  OPEN
  LOCKED
  CANCELLED
}

input OrderUpdate {
  note: String
  currencyCode: String
  supplierParty: OrderPartyBase
  customerParty: OrderPartyBase
  orderDelivery: OrderDeliveryBase
  bban: String
  iban: String
  reference: String
  export: Boolean
  taxAmount: Decimal
  lineExtensionAmount: Decimal
  taxExclusiveAmount: Decimal
  taxInclusiveAmount: Decimal
  payableAmount: Decimal
  unitId: ID
  customerId: ID
  carId: ID
  projectId: ID
  departmentId: ID
  logo: ExistingAttachmentInput
  orderLines: [OrderLineBase!]
  orderAllowanceCharges: [OrderAllowanceChargeBase!]
  id: ID!
  date: Date
}

input OrderUpdateInput {
  clientMutationId: String
  order: OrderUpdate!
}

type OrderUpdatePayload {
  clientMutationId: String
  order: Order
}

type Paycheck {
  advancedMode: Boolean!
  ameldings: [Amelding!]!
  comment: String
  companyMunicipality: Municipality!
  companyMunicipalityTaxRate: Decimal!
  createdAt: DateTime!
  createdBy: User!
  currency: Currency!
  currencyCode: String!
  draftSavedAt: DateTime!
  draftSavedBy: User!
  dueDate: Date!
  employeeAddress: String!
  employeeBban: String
  employeeCity: String!
  employeeIban: String
  employeeName: String!
  employeeSocialSecurityNumber: String
  employeeSwift: String
  employeeTemporarySocialSecurityNumber: String
  employeeZip: String!
  employerAddress: String!
  employerCity: String!
  employerName: String!
  employerOrganizationNumber: String!
  employerTaxAmount: Decimal!
  employerZip: String!
  employmentPercentage: Decimal
  employmentPercentageUpdated: Date
  employmentType: AltinnEmploymentTypeEnum!
  endDate: Date!
  hoursEveryWeekWithFullEmployment: Decimal
  id: ID!
  internalComment: String
  isSentToAltinn: Boolean!
  journalDate: Date!
  lastSalaryChange: Date
  leaveAndLayoffs: [WorkRelationLeaveAndLayoff!]!
  lockedAt: DateTime
  lockedBy: User
  logo: Attachment!
  number: Int!
  occupation: Occupation
  paidDate: Date
  paidDateUpdatedAt: DateTime
  paidDateUpdatedBy: User
  paidVacationMoneyEmployerTaxAmount: Decimal!
  paycheckLines: [PaycheckLine!]!
  pdf: Attachment!
  period: PaycheckPeriod!
  prepayments: [PaycheckPrepayment!]!
  samePositionSince: Date
  savedAt: DateTime!
  savedBy: User!
  sentToAltinnInReport: Amelding
  shiftType: AltinnShiftTypeEnum
  shouldSendToAltinn: Boolean!
  shouldSendToFakturabank: Boolean!
  startDate: Date!
  taxDeductionMethod: PaycheckTaxDeductionMethodEnum
  taxDeductionTooLowConfirmedAt: DateTime
  taxDeductionTooLowConfirmedBy: User
  taxExemption: Boolean!
  taxExemptionAmountLimit: Decimal
  taxPercentage: Decimal
  taxTable: String
  unit: Unit!
  vacationMoneyAmount: Decimal!
  vacationMoneyEmployerTaxAmount: Decimal!
  vacationMoneyPercentage: Decimal!
  workRelation: WorkRelation!
  workRelationDurationType: AltinnEmploymentDurationTypeEnum
  workRelationEndDate: Date
  workRelationEndReason: AltinnEmploymentEndReasonEnum
}

input PaycheckCreate {
  currencyCode: String!
  startDate: Date!
  endDate: Date!
  dueDate: Date!
  companyMunicipalityId: ID!
  employeeBban: String
  employeeIban: String
  employeeSwift: String
  paidDate: Date
  comment: String
  internalComment: String
  journalDate: Date!
  taxDeductionMethod: PaycheckTaxDeductionMethodEnum
  taxExemptionAmountLimit: Decimal
  shouldSendToAltinn: Boolean!
  shouldSendToFakturabank: Boolean!
  unitId: ID!
  workRelationId: ID!
  paycheckLines: [PaycheckLineCreate!]!
  prepayments: [PaycheckPrepaymentCreate!]
  periodId: ID!
  number: Int
  advancedMode: Boolean!
}

input PaycheckCreateInput {
  clientMutationId: String
  paycheck: PaycheckCreate!
}

type PaycheckCreatePayload {
  clientMutationId: String
  paycheck: Paycheck
}

type PaycheckDraft {
  active: Boolean!
  comment: String
  id: ID!
  openedBy: User!
  paycheck: Paycheck
  paycheckDraftLines: [PaycheckDraftLine!]!
  period: PaycheckPeriod!
  savedAt: DateTime!
  savedBy: User!
  workRelation: WorkRelation!
}

type PaycheckDraftLine {
  car: Car
  carOverwrite: Boolean!
  department: Department
  departmentOverwrite: Boolean!
  id: ID!
  paycheckLineTemplate: PaycheckLineTemplate!
  project: Project
  projectOverwrite: Boolean!
  quantity: Decimal!
  rate: Decimal!
  sum: Decimal!
}

input PaycheckDraftLineSave {
  id: ID
  _destroy: Boolean
  paycheckLineTemplateId: ID
  quantity: Decimal
  rate: Decimal
  sum: Decimal
  carId: ID
  projectId: ID
  departmentId: ID
  carOverwrite: Boolean
  projectOverwrite: Boolean
  departmentOverwrite: Boolean
}

input PaycheckDraftSave {
  id: ID
  workRelationId: ID
  periodId: ID
  active: Boolean
  comment: String
  paycheckDraftLines: [PaycheckDraftLineSave!]
}

input PaycheckDraftSaveInput {
  clientMutationId: String
  paycheckDrafts: [PaycheckDraftSave!]!
  unitId: ID!
}

type PaycheckDraftSavePayload {
  clientMutationId: String
  paycheckDrafts: [PaycheckDraft!]!
}

type PaycheckExport {
  content: String!
  id: ID!
  message: String!
  paycheck: Paycheck!
  status: String!
  unit: Unit!
  user: User!
}

input PaycheckFetchLinesFromTemplateInput {
  clientMutationId: String
  id: ID!
}

type PaycheckFetchLinesFromTemplatePayload {
  clientMutationId: String
  paycheck: Paycheck
}

input PaycheckFetchWorkRelationInfoInput {
  clientMutationId: String
  id: ID!
}

type PaycheckFetchWorkRelationInfoPayload {
  clientMutationId: String
  paycheck: Paycheck
}

input PaycheckFilter {
  number: String
  journalDate: String
  startDate: String
  endDate: String
  employeeName: String
  paidDate: String
  reported: PaycheckFilterReportedEnum
  reportedDate: String
  locked: Boolean
  advancedMode: Boolean
  shouldSendToAltinn: Boolean
  shouldSendToFakturabank: Boolean
}

enum PaycheckFilterReportedEnum {
  NOT_REPORTED
  SHOULD_REPORT
  REPORTED
}

type PaycheckLine {
  altinnAdditional: PaycheckLineTypeAltinnAdditional!
  altinnDescription: AltinnIncomeDescriptionEnum
  altinnFordel: AltinnFordelEnum
  calculatePositive: Boolean!
  calculationType: PaycheckLineCalculationTypeEnum!
  car: Car
  carOverwrite: Boolean!
  department: Department
  departmentOverwrite: Boolean!
  description: String!
  employerTaxable: Boolean!
  garnishment: Boolean!
  garnishmentSamordnet: Boolean!
  id: ID!
  includeInVacationMoneyBase: Boolean!
  number: Int!
  paycheckLineTemplate: PaycheckLineTemplate
  project: Project
  projectOverwrite: Boolean!
  quantity: Decimal!
  rate: Decimal!
  sum: Decimal!
  taxDeduction: Boolean!
  taxDeductionVoluntary: Boolean!
  taxable: Boolean!
  vacationMoneyEarnedInPreviousYear: Boolean!
}

input PaycheckLineBaseAltinnAdditional {
  carAndBoat: PaycheckLineBaseAltinnCarAndBoat
}

input PaycheckLineBaseAltinnCarAndBoat {
  listPriceForCar: Decimal
  carRegistrationNumber: String
}

enum PaycheckLineCalculationTypeEnum {
  CASHEDOUT
  CALCULATED
}

input PaycheckLineCreate {
  paycheckLineTemplateId: ID!
  quantity: Decimal!
  rate: Decimal!
  sum: Decimal!
  carId: ID
  projectId: ID
  departmentId: ID
  altinnAdditional: PaycheckLineBaseAltinnAdditional
}

type PaycheckLineTaxDeductionVoluntaryNewResult {
  paycheckLine: PaycheckNewLine!
}

type PaycheckLineTemplate {
  active: Boolean!
  car: Car
  carOverwrite: Boolean!
  department: Department
  departmentOverwrite: Boolean!
  id: ID!
  mainPaycheckLineTemplate: MainPaycheckLineTemplate!
  project: Project
  projectOverwrite: Boolean!
  quantity: Decimal!
  rate: Decimal!
  sum: Decimal!
  workRelation: WorkRelation
}

input PaycheckLineTemplateUpdate {
  id: ID
  mainPaycheckLineTemplateId: ID
  workRelationId: ID
  active: Boolean
  quantity: Decimal
  rate: Decimal
  sum: Decimal
  carId: ID
  projectId: ID
  departmentId: ID
  carOverwrite: Boolean
  projectOverwrite: Boolean
  departmentOverwrite: Boolean
}

input PaycheckLineTemplateUpdateInput {
  clientMutationId: String
  paycheckLineTemplates: [PaycheckLineTemplateUpdate!]!
}

type PaycheckLineTemplateUpdatePayload {
  clientMutationId: String
  paycheckLineTemplates: [PaycheckLineTemplate!]!
}

type PaycheckLineTypeAltinnAdditional {
  carAndBoat: PaycheckLineTypeAltinnCarAndBoat!
}

type PaycheckLineTypeAltinnCarAndBoat {
  carRegistrationNumber: String
  listPriceForCar: Decimal
}

input PaycheckLineUpdate {
  paycheckLineTemplateId: ID
  quantity: Decimal
  rate: Decimal
  sum: Decimal
  carId: ID
  projectId: ID
  departmentId: ID
  altinnAdditional: PaycheckLineBaseAltinnAdditional
  id: ID
  _destroy: Boolean
}

input PaycheckLockInput {
  clientMutationId: String
  id: ID!
  taxDeductionTooLowConfirmed: Boolean!
}

type PaycheckLockPayload {
  clientMutationId: String
  paycheck: Paycheck
  paycheckExport: PaycheckExport
}

type PaycheckNew {
  advancedMode: Boolean!
  ameldings: [Amelding!]!
  comment: String
  companyMunicipality: Municipality!
  companyMunicipalityTaxRate: Decimal!
  createdAt: Date
  createdBy: User
  currency: Currency!
  currencyCode: String!
  draftSavedAt: DateTime!
  draftSavedBy: User!
  dueDate: Date!
  employeeAddress: String!
  employeeBban: String
  employeeCity: String!
  employeeIban: String
  employeeName: String!
  employeeSocialSecurityNumber: String
  employeeSwift: String
  employeeTemporarySocialSecurityNumber: String
  employeeZip: String!
  employerAddress: String!
  employerCity: String!
  employerName: String!
  employerOrganizationNumber: String!
  employerTaxAmount: Decimal!
  employerZip: String!
  employmentPercentage: Decimal
  employmentPercentageUpdated: Date
  employmentType: AltinnEmploymentTypeEnum!
  endDate: Date!
  hoursEveryWeekWithFullEmployment: Decimal
  id: ID
  internalComment: String
  isSentToAltinn: Boolean!
  journalDate: Date!
  lastSalaryChange: Date
  leaveAndLayoffs: [WorkRelationLeaveAndLayoff!]!
  lockedAt: DateTime
  lockedBy: User
  logo: Attachment!
  number: Int
  occupation: Occupation
  paidDate: Date
  paidDateUpdatedAt: DateTime
  paidDateUpdatedBy: User
  paidVacationMoneyEmployerTaxAmount: Decimal!
  paycheckLines: [PaycheckNewLine!]!
  pdf: Attachment!
  period: PaycheckPeriod!
  prepayments: [PaycheckNewPrepayment!]!
  samePositionSince: Date
  savedAt: DateTime
  savedBy: User
  sentToAltinnInReport: Amelding
  shiftType: AltinnShiftTypeEnum
  shouldSendToAltinn: Boolean!
  shouldSendToFakturabank: Boolean!
  startDate: Date!
  taxDeductionMethod: PaycheckTaxDeductionMethodEnum
  taxDeductionTooLowConfirmedAt: DateTime
  taxDeductionTooLowConfirmedBy: User
  taxExemption: Boolean!
  taxExemptionAmountLimit: Decimal
  taxPercentage: Decimal
  taxTable: String
  unit: Unit!
  vacationMoneyAmount: Decimal!
  vacationMoneyEmployerTaxAmount: Decimal!
  vacationMoneyPercentage: Decimal!
  workRelation: WorkRelation!
  workRelationDurationType: AltinnEmploymentDurationTypeEnum
  workRelationEndDate: Date
  workRelationEndReason: AltinnEmploymentEndReasonEnum
}

type PaycheckNewLine {
  altinnAdditional: PaycheckLineTypeAltinnAdditional!
  altinnDescription: AltinnIncomeDescriptionEnum
  altinnFordel: AltinnFordelEnum
  calculatePositive: Boolean!
  calculationType: PaycheckLineCalculationTypeEnum!
  car: Car
  carOverwrite: Boolean!
  department: Department
  departmentOverwrite: Boolean!
  description: String!
  employerTaxable: Boolean!
  garnishment: Boolean!
  garnishmentSamordnet: Boolean!
  id: ID
  includeInVacationMoneyBase: Boolean!
  number: Int!
  paycheckLineTemplate: PaycheckLineTemplate!
  project: Project
  projectOverwrite: Boolean!
  quantity: Decimal!
  rate: Decimal!
  sum: Decimal!
  taxDeduction: Boolean!
  taxDeductionVoluntary: Boolean!
  taxable: Boolean!
  vacationMoneyEarnedInPreviousYear: Boolean!
}

type PaycheckNewPrepayment {
  amount: Decimal!
  id: ID
  paycheck: PaycheckNew!
  paymentDate: Date
}

input PaycheckPaidDateUpdateInput {
  clientMutationId: String
  id: ID!
  paidDate: Date
}

type PaycheckPaidDateUpdatePayload {
  clientMutationId: String
  paycheck: Paycheck
}

type PaycheckPeriod {
  bookkeepingPeriod: String!
  endDate: Date!
  id: ID!
  isInUse: Boolean!
  isLocked: Boolean!
  journalDate: Date!
  name: String!
  paycheckCount: Int!
  startDate: Date!
}

input PaycheckPeriodSave {
  id: ID
  name: String
  bookkeepingPeriod: String
  isLocked: Boolean
  startDate: Date
  endDate: Date
  journalDate: Date
  _destroy: Boolean
}

input PaycheckPeriodSaveInput {
  clientMutationId: String
  paycheckPeriods: [PaycheckPeriodSave!]!
  unitId: ID!
}

type PaycheckPeriodSavePayload {
  clientMutationId: String
  paycheckPeriods: [PaycheckPeriod!]!
}

type PaycheckPrepayment {
  amount: Decimal!
  id: ID!
  paycheck: Paycheck!
  paymentDate: Date
}

input PaycheckPrepaymentCreate {
  amount: Decimal!
  paymentDate: Date!
}

input PaycheckPrepaymentUpdate {
  id: ID
  _destroy: Boolean
  amount: Decimal
  paymentDate: Date
}

input PaycheckRevertInput {
  clientMutationId: String
  id: ID!
}

type PaycheckRevertPayload {
  clientMutationId: String
  paycheck: Paycheck
}

type PaychecksAndBookkeepingReconciliationReportBookkeptTable {
  footer: PaychecksAndBookkeepingReconciliationReportBookkeptTableFooter!
  rows: [PaychecksAndBookkeepingReconciliationReportBookkeptTableRow!]!
}

type PaychecksAndBookkeepingReconciliationReportBookkeptTableFooter {
  columns: [Decimal!]!
  vacationMoneyBaseUnpaid: Decimal!
}

type PaychecksAndBookkeepingReconciliationReportBookkeptTableRow {
  bookkeepingAccountName: String!
  bookkeepingAccountNumber: String!
  columns: [Decimal!]!
  vacationMoneyBaseUnpaid: Decimal!
}

type PaychecksAndBookkeepingReconciliationReportDiffTable {
  bookkeptTableSums: PaychecksAndBookkeepingReconciliationReportDiffTableRow!
  diff: PaychecksAndBookkeepingReconciliationReportDiffTableRow!
  paycheckSummaryTableSums: PaychecksAndBookkeepingReconciliationReportDiffTableRow!
  paychecksInYearNotPaidInYearSums: PaychecksAndBookkeepingReconciliationReportDiffTableRow!
  paychecksNotInYearPaidInYearSums: PaychecksAndBookkeepingReconciliationReportDiffTableRow!
}

type PaychecksAndBookkeepingReconciliationReportDiffTableRow {
  columns: [Decimal!]!
  vacationMoneyBaseUnpaid: Decimal!
}

type PaychecksAndBookkeepingReconciliationReportHeader {
  description: String!
}

type PaychecksAndBookkeepingReconciliationReportPaychecksInYearNotPaidInYear {
  footer: PaychecksAndBookkeepingReconciliationReportPaychecksInYearNotPaidInYearFooter!
  rows: [PaychecksAndBookkeepingReconciliationReportPaychecksInYearNotPaidInYearRow!]!
}

type PaychecksAndBookkeepingReconciliationReportPaychecksInYearNotPaidInYearFooter {
  columns: [Decimal!]!
  vacationMoneyBaseUnpaid: Decimal!
}

type PaychecksAndBookkeepingReconciliationReportPaychecksInYearNotPaidInYearRow {
  columns: [Decimal!]!
  paycheck: Paycheck!
  vacationMoneyBaseUnpaid: Decimal!
}

type PaychecksAndBookkeepingReconciliationReportPaychecksNotInYearPaidInYear {
  footer: PaychecksAndBookkeepingReconciliationReportPaychecksNotInYearPaidInYearFooter!
  rows: [PaychecksAndBookkeepingReconciliationReportPaychecksNotInYearPaidInYearRow!]!
}

type PaychecksAndBookkeepingReconciliationReportPaychecksNotInYearPaidInYearFooter {
  columns: [Decimal!]!
  vacationMoneyBaseUnpaid: Decimal!
}

type PaychecksAndBookkeepingReconciliationReportPaychecksNotInYearPaidInYearRow {
  columns: [Decimal!]!
  paycheck: Paycheck!
  vacationMoneyBaseUnpaid: Decimal!
}

type PaychecksAndBookkeepingReconciliationReportPaycheckSummaryTable {
  footer: PaychecksAndBookkeepingReconciliationReportPaycheckSummaryTableFooter!
  rows: [PaychecksAndBookkeepingReconciliationReportPaycheckSummaryTableRow!]!
}

type PaychecksAndBookkeepingReconciliationReportPaycheckSummaryTableFooter {
  columns: [Decimal!]!
  vacationMoneyBaseUnpaid: Decimal!
}

type PaychecksAndBookkeepingReconciliationReportPaycheckSummaryTableRow {
  columns: [Decimal!]!
  vacationMoneyBaseUnpaid: Decimal!
  workRelation: WorkRelation!
}

type PaychecksAndBookkeepingReconciliationReportRoot {
  bookkeptTable: PaychecksAndBookkeepingReconciliationReportBookkeptTable!
  columnHeaders: [PaychecksAndBookkeepingReconciliationReportHeader!]!
  diffTable: PaychecksAndBookkeepingReconciliationReportDiffTable!
  paycheckSummaryTable: PaychecksAndBookkeepingReconciliationReportPaycheckSummaryTable!
  paychecksInYearNotPaidInYear: PaychecksAndBookkeepingReconciliationReportPaychecksInYearNotPaidInYear!
  paychecksNotInYearPaidInYear: PaychecksAndBookkeepingReconciliationReportPaychecksNotInYearPaidInYear!
}

type PaycheckSearchPaycheck {
  advancedMode: Boolean!
  ameldings: [Amelding!]!
  comment: String
  companyMunicipality: Municipality!
  companyMunicipalityTaxRate: Decimal!
  createdAt: DateTime!
  createdBy: User!
  currency: Currency!
  currencyCode: String!
  draftSavedAt: DateTime!
  draftSavedBy: User!
  dueDate: Date!
  employeeAddress: String!
  employeeBban: String
  employeeCity: String!
  employeeIban: String
  employeeName: String!
  employeeSocialSecurityNumber: String
  employeeSwift: String
  employeeTemporarySocialSecurityNumber: String
  employeeZip: String!
  employerAddress: String!
  employerCity: String!
  employerName: String!
  employerOrganizationNumber: String!
  employerTaxAmount: Decimal!
  employerZip: String!
  employmentPercentage: Decimal
  employmentPercentageUpdated: Date
  employmentType: AltinnEmploymentTypeEnum!
  endDate: Date!
  hoursEveryWeekWithFullEmployment: Decimal
  id: ID!
  internalComment: String
  isSentToAltinn: Boolean!
  journalDate: Date!
  lastSalaryChange: Date
  leaveAndLayoffs: [WorkRelationLeaveAndLayoff!]!
  locked: Boolean!
  lockedAt: DateTime
  lockedBy: User
  logo: Attachment!
  number: Int!
  occupation: Occupation
  paidDate: Date
  paidDateUpdatedAt: DateTime
  paidDateUpdatedBy: User
  paidVacationMoneyEmployerTaxAmount: Decimal!
  paycheckLines: [PaycheckLine!]!
  pdf: Attachment!
  period: PaycheckPeriod!
  prepayments: [PaycheckPrepayment!]!
  reportedDate: Date
  samePositionSince: Date
  savedAt: DateTime!
  savedBy: User!
  sentToAltinnInReport: Amelding
  shiftType: AltinnShiftTypeEnum
  shouldSendToAltinn: Boolean!
  shouldSendToFakturabank: Boolean!
  startDate: Date!
  taxDeductionMethod: PaycheckTaxDeductionMethodEnum
  taxDeductionTooLowConfirmedAt: DateTime
  taxDeductionTooLowConfirmedBy: User
  taxExemption: Boolean!
  taxExemptionAmountLimit: Decimal
  taxPercentage: Decimal
  taxTable: String
  unit: Unit!
  vacationMoneyAmount: Decimal!
  vacationMoneyEmployerTaxAmount: Decimal!
  vacationMoneyPercentage: Decimal!
  workRelation: WorkRelation!
  workRelationDurationType: AltinnEmploymentDurationTypeEnum
  workRelationEndDate: Date
  workRelationEndReason: AltinnEmploymentEndReasonEnum
}

type PaycheckSearchSummary {
  lines: [PaycheckSearchSummaryLine!]!
}

type PaycheckSearchSummaryLine {
  calculationType: PaycheckLineCalculationTypeEnum!
  car: Car
  department: Department
  description: String!
  number: Int!
  project: Project
  sum: Decimal!
}

type PaycheckStartNumberSet {
  paycheckNumberSet: Boolean!
}

type PaycheckSum {
  altinnFordel: AltinnFordelEnum
  calculationType: PaycheckLineCalculationTypeEnum!
  description: String!
  number: Int!
  sum: Decimal!
}

enum PaycheckTaxDeductionMethodEnum {
  MAIN_EMPLOYER_TABLE
  MAIN_EMPLOYER_PERCENTAGE
  SECONDARY_EMPLOYER_PERCENTAGE
  TAX_EXEMPTION
}

input PaycheckUpdate {
  currencyCode: String
  startDate: Date
  endDate: Date
  dueDate: Date
  companyMunicipalityId: ID
  employeeBban: String
  employeeIban: String
  employeeSwift: String
  paidDate: Date
  comment: String
  internalComment: String
  journalDate: Date
  taxDeductionMethod: PaycheckTaxDeductionMethodEnum
  taxExemptionAmountLimit: Decimal
  shouldSendToAltinn: Boolean
  shouldSendToFakturabank: Boolean
  id: ID!
  paycheckLines: [PaycheckLineUpdate!]
  prepayments: [PaycheckPrepaymentUpdate!]
}

input PaycheckUpdateInput {
  clientMutationId: String
  paycheck: PaycheckUpdate!
}

type PaycheckUpdatePayload {
  clientMutationId: String
  paycheck: Paycheck
}

type PaymentMethod {
  id: ID!
  name: String!
}

input PaymentMethodCreate {
  name: String!
  unitId: ID!
}

input PaymentMethodCreateInput {
  clientMutationId: String
  paymentMethod: PaymentMethodCreate!
}

type PaymentMethodCreatePayload {
  clientMutationId: String
  paymentMethod: PaymentMethod
}

input PaymentMethodDeleteInput {
  clientMutationId: String
  id: ID!
}

type PaymentMethodDeletePayload {
  clientMutationId: String
  paymentMethod: PaymentMethod
}

input PaymentMethodUpdate {
  name: String
  id: ID!
}

input PaymentMethodUpdateInput {
  clientMutationId: String
  paymentMethod: PaymentMethodUpdate!
}

type PaymentMethodUpdatePayload {
  clientMutationId: String
  paymentMethod: PaymentMethod
}

type PensionUnitSelection {
  id: ID!
  isSentToAltinn: Boolean!
  minimalValidTo: Date
  pensionUnit: Unit!
  validFrom: Date!
  validTo: Date
}

input PensionUnitSelectionCreate {
  unitId: ID!
  pensionUnitId: ID!
  validFrom: Date!
  validTo: Date
}

input PensionUnitSelectionCreateInput {
  clientMutationId: String
  pensionUnitSelection: PensionUnitSelectionCreate!
}

type PensionUnitSelectionCreatePayload {
  clientMutationId: String
  pensionUnitSelection: PensionUnitSelection
}

input PensionUnitSelectionUpdate {
  id: ID!
  pensionUnitId: ID
  validFrom: Date
  validTo: Date
}

input PensionUnitSelectionUpdateInput {
  clientMutationId: String
  pensionUnitSelection: PensionUnitSelectionUpdate!
}

type PensionUnitSelectionUpdatePayload {
  clientMutationId: String
  pensionUnitSelection: PensionUnitSelection
}

type Permissions {
  canAddMonthlyYearlyComment: Boolean!
  canAdminUnitEntities: Boolean!
  canAssignRole: Boolean!
  canCreateAdvancedPaychecks: Boolean!
  canCreatePaychecks: Boolean!
  canDoAccountingLvl1: Boolean!
  canDoAccountingLvl2: Boolean!
  canDoLiveSupport: Boolean!
  canDoOcr: Boolean!
  canDoPayments: Boolean!
  canEditChargingReport: Boolean!
  canEditDocuments: Boolean!
  canEditEmployees: Boolean!
  canEditGlobalBookkeeping: Boolean!
  canEditMonthlyYearlyComment: Boolean!
  canEditTutorials: Boolean!
  canGenerateVatReport: Boolean!
  canLockPunching: Boolean!
  canManageCashRegister: Boolean!
  canManageXml: Boolean!
  canMoveUploadedScans: Boolean!
  canPermanentlyDeleteUploadedScans: Boolean!
  canPunchBankStatement: Boolean!
  canPunchBankTransaction: Boolean!
  canPunchGiro: Boolean!
  canPunchInvoiceInfo: Boolean!
  canPunchInvoiceLines: Boolean!
  canPunchInvoiceno: Boolean!
  canPunchJournalNumber: Boolean!
  canPunchOtherDocuments: Boolean!
  canReassignScan: Boolean!
  canReconciliate: Boolean!
  canRejectInvoice: Boolean!
  canSendAltinnPaycheckReports: Boolean!
  canSendBuyerInvoice: Boolean!
  canSendCustomerReminders: Boolean!
  canSendEconomyReport: Boolean!
  canSendPaychecks: Boolean!
  canSendSellerInvoice: Boolean!
  canShareInvoicesWithUsers: Boolean!
  canUpdateAdmin: Boolean!
  canUpdateProducts: Boolean!
  canUpdateUnit: Boolean!
  canUploadScan: Boolean!
  canViewAccounting: Boolean!
  canViewAccountingInfo: Boolean!
  canViewBalanceReport: Boolean!
  canViewBankStatementAndTransaction: Boolean!
  canViewChargingReport: Boolean!
  canViewCommentThreads: Boolean!
  canViewCremulData: Boolean!
  canViewGiro: Boolean!
  canViewInvoiceLog: Boolean!
  canViewOtherDocuments: Boolean!
  canViewPurchases: Boolean!
  canViewReports: Boolean!
  canViewSalaries: Boolean!
  canViewSales: Boolean!
  canViewUploadedScans: Boolean!
  canViewWorkDoneForOthers: Boolean!
  isSuperAdmin: Boolean!
}

type Product {
  car: Car
  createdBy: User!
  department: Department
  description: String
  firstWarehousePatch: WarehousePatch
  id: ID!
  images: [Attachment!]!
  name: String!
  number: String!
  productActivePeriods: [ProductActivePeriod!]!
  productGroup: ProductGroup
  productPrices: [ProductPrice!]!
  project: Project
  supplierUnit: Unit
  suppliersProductNumber: String
  taxExemptionReason: String
  unit: Unit!
  unitOfMeasureCode: String!
  vatRateSymbol: NorwegianVatSymbolEnum!
}

type ProductActivePeriod {
  activeFrom: Date!
  activeTo: Date
  id: ID!
  product: Product!
}

input ProductActivePeriodCreate {
  activeFrom: Date!
  activeTo: Date
}

input ProductActivePeriodUpdate {
  activeFrom: Date
  activeTo: Date
  id: ID
  _destroy: Boolean
}

input ProductCreate {
  number: String!
  name: String!
  description: String
  unitOfMeasureCode: String!
  carId: ID
  projectId: ID
  departmentId: ID
  vatRateSymbol: NorwegianVatSymbolEnum!
  taxExemptionReason: String
  productGroupId: ID
  supplierUnitId: ID
  suppliersProductNumber: String
  images: [FileUpload!]
  unitId: ID!
  productPrices: [ProductPriceCreate!]
  productActivePeriods: [ProductActivePeriodCreate!]
}

input ProductCreateInput {
  clientMutationId: String
  product: ProductCreate!
}

type ProductCreatePayload {
  clientMutationId: String
  product: Product
}

input ProductDeleteInput {
  clientMutationId: String
  id: ID!
}

type ProductDeletePayload {
  clientMutationId: String
  product: Product
}

input ProductFilter {
  number: String
  exactNumber: String
  numberAndName: String
  name: String
  productGroupId: ID
  car: String
  project: String
  department: String
  createdBy: String
  supplierUnitId: ID
  activeDate: String
  withAnySupplier: Boolean
}

type ProductGroup {
  description: String
  fullPathName: String!
  id: ID!
  name: String!
  parentGroup: ProductGroup
  products: [Product!]!
  subgroups: [ProductGroup!]!
}

input ProductGroupCreate {
  name: String!
  description: String
  parentGroupId: ID
  unitId: ID!
}

input ProductGroupCreateInput {
  clientMutationId: String
  productGroup: ProductGroupCreate!
}

type ProductGroupCreatePayload {
  clientMutationId: String
  productGroup: ProductGroup
}

input ProductGroupDeleteInput {
  clientMutationId: String
  id: ID!
}

type ProductGroupDeletePayload {
  clientMutationId: String
  productGroup: ProductGroup
}

input ProductGroupUpdate {
  name: String
  description: String
  parentGroupId: ID
  id: ID!
}

input ProductGroupUpdateInput {
  clientMutationId: String
  productGroup: ProductGroupUpdate!
}

type ProductGroupUpdatePayload {
  clientMutationId: String
  productGroup: ProductGroup
}

type ProductPrice {
  contributionMargin: Decimal!
  contributionMarginPercentage: Decimal!
  id: ID!
  product: Product!
  purchasePrice: Decimal!
  salePrice: Decimal!
  validFrom: Date!
  validTo: Date
}

input ProductPriceCreate {
  validFrom: Date!
  validTo: Date
  purchasePrice: Decimal!
  salePrice: Decimal!
}

input ProductPriceUpdate {
  validFrom: Date
  validTo: Date
  purchasePrice: Decimal
  salePrice: Decimal
  id: ID
  _destroy: Boolean
}

input ProductUpdate {
  number: String
  name: String
  description: String
  unitOfMeasureCode: String
  carId: ID
  projectId: ID
  departmentId: ID
  vatRateSymbol: NorwegianVatSymbolEnum
  taxExemptionReason: String
  productGroupId: ID
  supplierUnitId: ID
  suppliersProductNumber: String
  images: [FileUpload!]
  id: ID!
  productPrices: [ProductPriceUpdate!]
  productActivePeriods: [ProductActivePeriodUpdate!]
}

input ProductUpdateInput {
  clientMutationId: String
  product: ProductUpdate!
}

type ProductUpdatePayload {
  clientMutationId: String
  product: Product
}

type ProductVariant {
  id: ID!
  name: String!
  product: Product!
}

input ProductVariantCreate {
  name: String!
  productId: ID!
}

type ProductVariantHolder {
  attributeName: String!
  description: String
  id: ID!
  name: String!
  variants: [ProductVariant!]!
}

input ProductVariantHolderCreate {
  name: String!
  attributeName: String!
  description: String
  unitId: ID!
  variants: [ProductVariantCreate!]!
}

input ProductVariantHolderCreateInput {
  clientMutationId: String
  productVariantHolder: ProductVariantHolderCreate!
}

type ProductVariantHolderCreatePayload {
  clientMutationId: String
  productVariantHolder: ProductVariantHolder
}

input ProductVariantHolderDeleteInput {
  clientMutationId: String
  id: ID!
}

type ProductVariantHolderDeletePayload {
  clientMutationId: String
  productVariantHolder: ProductVariantHolder
}

input ProductVariantHolderUpdate {
  name: String
  attributeName: String
  description: String
  id: ID!
  variants: [ProductVariantUpdate!]
}

input ProductVariantHolderUpdateInput {
  clientMutationId: String
  productVariantHolder: ProductVariantHolderUpdate!
}

type ProductVariantHolderUpdatePayload {
  clientMutationId: String
  productVariantHolder: ProductVariantHolder
}

input ProductVariantUpdate {
  name: String
  productId: ID
  id: ID
  _destroy: Boolean
}

type Project {
  code: String!
  id: ID!
  name: String!
  unit: Unit!
}

input ProjectCreate {
  code: String!
  name: String!
  unitId: ID!
}

input ProjectCreateInput {
  clientMutationId: String
  project: ProjectCreate!
}

type ProjectCreatePayload {
  clientMutationId: String
  project: Project
}

input ProjectDeleteInput {
  clientMutationId: String
  id: ID!
}

type ProjectDeletePayload {
  clientMutationId: String
  project: Project
}

input ProjectUpdate {
  code: String
  name: String
  id: ID!
}

input ProjectUpdateInput {
  clientMutationId: String
  project: ProjectUpdate!
}

type ProjectUpdatePayload {
  clientMutationId: String
  project: Project
}

type Query {
  allCountries: [Country!]!
  allCurrencies: [Currency!]!
  allIdentificators: [Identificator!]!
  allNorwegianVatRates: [NorwegianVatRate!]!
  allUsers: [User!]!
  altinn3SystemUserConfirmationUrl: String
  altinnTaxInvoicePreviews(calendarMonth: String!): [AltinnTaxInvoicePreview!]
  amelding(id: ID!): Amelding
  ameldingAndBookkeepingReconciliationReport(unitId: ID!, year: Int!): AmeldingAndBookkeepingReconciliationReportRoot!
  ameldingReconciliationReports(year: String!, unitId: ID!): [AmeldingReconciliationReport!]!
  ameldings(year: String = null, calendarMonth: String = null, unitId: ID!): [Amelding!]!
  appSettings: AppSettings!
  car(id: ID!): Car
  currentUnit: Unit!
  currentUser: User
  customer(id: ID!): Customer
  customerPaymentBehaviourReport(unitId: ID!, from: Date!, to: Date!): [ReportCustomerPaymentBehaviour!]!
  customers(limit: Int = 100, offset: Int = 0, orderBy: String = "unit_name", orderDirection: String = "asc", filters: CustomerFilter = {}): [Customer!]!
  department(id: ID!): Department
  efakturaSetup: Boolean!
  employee(id: ID!): Employee
  employeeSearch(ssn: String, tssn: String, email: String!, phone: String!): EmployeeSearch
  failedInvoiceDeliveries(limit: Int = 5): [Invoice!]!
  fbBookkeepingAccounts(unitId: ID!): [AmeldingAndBookkeepingReconciliationReportFbBookkeepingAccount!]!
  generalInvoiceStatistics(from: String!, to: String!, fields: [String!]!, interval: ReportIntervalEnum = MONTHLY, unitId: ID = null): [ReportGeneralInvoiceStatistic!]!
  governmentCarSearch(registration: String!): GovernmentCar
  invoice(id: ID!): Invoice
  invoiceOverdueNotice(id: ID!): InvoiceOverdueNotice
  invoices(limit: Int = 100, offset: Int = 0, orderBy: String = "number", orderDirection: String = "desc", onlyOverdue: Boolean = false, filters: InvoiceFilter = {}): [Invoice!]!
  mainPaycheckLineTemplates: [MainPaycheckLineTemplate!]!
  municipalitySearch(limit: Int = 100, offset: Int = 0, term: String!): [Municipality!]!
  municipalitySelections(unitId: ID!): [MunicipalitySelection!]!
  newInvoice(orderIds: [ID!]!): Invoice
  newPaycheck(workRelationId: ID!, periodId: ID!): PaycheckNew!
  norwegianPostCity(zip: String!): String
  occupationSearch(limit: Int = 100, offset: Int = 0, term: String!): [Occupation!]!
  occupationSelections(unitId: ID!): [OccupationSelection!]!
  order(id: ID!): Order
  orderInvoiceStartNumberSet: OrderInvoiceStartNumberSet!
  orders(limit: Int = 100, offset: Int = 0, orderBy: String = "number", orderDirection: String = "desc", filters: OrderFilter = {}): [Order!]!
  paycheck(id: ID!): Paycheck
  paycheckLineTaxDeductionVoluntaryNew(workRelationId: ID!): PaycheckLineTaxDeductionVoluntaryNewResult!
  paycheckStartNumberSet: PaycheckStartNumberSet!
  paychecks(limit: Int = 100, offset: Int = 0, orderBy: String = "number", orderDirection: String = "desc", filters: PaycheckFilter = {}): [PaycheckSearchPaycheck!]!
  paychecksAndBookkeepingReconciliationReport(unitId: ID!, year: Int!): PaychecksAndBookkeepingReconciliationReportRoot!
  paychecksByYear(year: Int!, unitId: ID!, workRelationId: ID): [Paycheck!]!
  paychecksSummary(filters: PaycheckFilter = {}): PaycheckSearchSummary!
  paymentMethod(id: ID!): PaymentMethod
  pensionUnitSelection(id: ID!): PensionUnitSelection
  product(id: ID!): Product
  productGroup(id: ID!): ProductGroup
  productVariantHolder(id: ID!): ProductVariantHolder
  products(limit: Int = 100, offset: Int = 0, orderBy: String = "number", orderDirection: String = "asc", filters: ProductFilter = {}): [Product!]!
  project(id: ID!): Project
  recurringOrder(id: ID!): RecurringOrder
  salaryTaxTableTaxDeduction(taxTable: String!, amount: Decimal!, year: Int!): SalaryTaxDeduction!
  settingsVacationMoneyReport(year: Int!, unitId: ID!): SettingsVacationMoneyReport!
  subUnit(id: ID!): SubUnit
  taxDeductionToPay(year: Int!): [TaxDeductionToPayTaxDeductionToPayMonth!]!
  unit(id: ID!): Unit
  unitFind(identificator: String!, value: String!): Unit
  unitSearch(limit: Int = 100, offset: Int = 0, term: String!, isCompany: Boolean, isPensionCompany: Boolean, date: Date!): [Unit!]!
  unitsOfMeasure: [UnitOfMeasure!]!
  user(id: ID!): User
  vacationMoneyReport(year: Int!, unitId: ID!): [ReportVacationMoney!]!
  warehousePatch(id: ID!): WarehousePatch
  warehouseProductReport(date: Date!, unitId: ID!, includeUnlockedOrders: Boolean!): WarehouseProductReport!
  webstoreApiToken(id: ID!): WebstoreApiToken
  workRelation(id: ID!): WorkRelation
  workRelationTimesheet(workRelationId: ID!, calendarMonth: String!): WorkRelationTimesheet
  yearlyReportForEmployee(year: Int!, unitId: ID!, workRelationId: ID): [ReportYearlyReportForEmployee!]!
}

type RecurringOrder {
  accountingCost: String
  bban: String
  cancelledAt: DateTime
  cancelledBy: User
  car: Car
  createdBy: User!
  currency: Currency!
  currencyCode: String!
  customer: Customer!
  customerParty: OrderParty!
  date: Date
  department: Department
  export: Boolean!
  iban: String
  id: ID!
  invoice: Invoice
  isCancelled: Boolean!
  isLocked: Boolean!
  isOpen: Boolean!
  lineExtensionAmount: Decimal!
  lockedAt: DateTime
  lockedBy: User
  logo: Attachment!
  note: String
  number: Int
  offerMailLogs: [LogOrderMail!]!
  offerPdf: Attachment!
  orderAllowanceCharges: [OrderAllowanceCharge!]!
  orderConfirmationMailLogs: [LogOrderMail!]!
  orderConfirmationPdf: Attachment!
  orderDelivery: OrderDelivery!
  orderLines: [OrderLine!]!
  orderMailLogs: [LogOrderMail!]!
  orderPdf: Attachment!
  packingSlipMailLogs: [LogOrderMail!]!
  packingSlipPdf: Attachment!
  payableAmount: Decimal!
  project: Project
  recurringOrderSetting: RecurringOrderSetting!
  reference: String
  savedAt: DateTime!
  savedBy: User
  status: OrderStatusEnum!
  supplierParty: OrderParty!
  taxAmount: Decimal!
  taxExclusiveAmount: Decimal!
  taxInclusiveAmount: Decimal!
  unit: Unit!
}

input RecurringOrderCreate {
  note: String
  currencyCode: String!
  supplierParty: OrderPartyBase!
  customerParty: OrderPartyBase!
  orderDelivery: OrderDeliveryBase!
  bban: String
  iban: String
  reference: String
  export: Boolean
  taxAmount: Decimal!
  lineExtensionAmount: Decimal!
  taxExclusiveAmount: Decimal!
  taxInclusiveAmount: Decimal!
  payableAmount: Decimal!
  unitId: ID!
  customerId: ID!
  carId: ID
  projectId: ID
  departmentId: ID
  logo: ExistingAttachmentInput
  orderLines: [OrderLineBase!]
  orderAllowanceCharges: [OrderAllowanceChargeBase!]
  recurringOrderSetting: RecurringOrderSettingBase!
}

input RecurringOrderCreateInput {
  clientMutationId: String
  recurringOrder: RecurringOrderCreate!
}

type RecurringOrderCreatePayload {
  clientMutationId: String
  recurringOrder: RecurringOrder
}

type RecurringOrderSetting {
  active: Boolean!
  dateOffset: Int!
  endDate: Date
  id: ID!
  interval: String!
  lastDateCreatedOn: Date
  nextDate: Date
  startDate: Date!
}

input RecurringOrderSettingBase {
  id: ID
  active: Boolean
  startDate: Date
  endDate: Date
  dateOffset: Int
  interval: String
}

input RecurringOrderUpdate {
  note: String
  currencyCode: String
  supplierParty: OrderPartyBase
  customerParty: OrderPartyBase
  orderDelivery: OrderDeliveryBase
  bban: String
  iban: String
  reference: String
  export: Boolean
  taxAmount: Decimal
  lineExtensionAmount: Decimal
  taxExclusiveAmount: Decimal
  taxInclusiveAmount: Decimal
  payableAmount: Decimal
  unitId: ID
  customerId: ID
  carId: ID
  projectId: ID
  departmentId: ID
  logo: ExistingAttachmentInput
  orderLines: [OrderLineBase!]
  orderAllowanceCharges: [OrderAllowanceChargeBase!]
  recurringOrderSetting: RecurringOrderSettingBase
  id: ID!
}

input RecurringOrderUpdateInput {
  clientMutationId: String
  recurringOrder: RecurringOrderUpdate!
}

type RecurringOrderUpdatePayload {
  clientMutationId: String
  recurringOrder: RecurringOrder
}

type ReportCustomerPaymentBehaviour {
  averageDaysLate: Decimal
  customer: Customer!
  interestChargesCount: Int!
  invoicedAmount: Decimal!
  invoicesCount: Int!
  longestOverdueDays: Int
  maxDaysLate: Int
  overdueAmount: Decimal!
  overdueCount: Int!
  paidCount: Int!
  paidLateCount: Int!
  paidOnTimeCount: Int!
  remindersCount: Int!
  unpaidCount: Int!
}

type ReportGeneralInvoiceStatistic {
  numberOfInvoices: Int
  period: String!
  totalExcludingTax: Decimal
  totalIncludingTax: Decimal
  unit: Unit!
}

enum ReportIntervalEnum {
  DAILY
  WEEKLY
  MONTHLY
  YEARLY
}

type ReportVacationMoney {
  employersTaxAmount: Decimal!
  employersTaxRealAmount: Decimal!
  leftToPayNextYearAmount: Decimal!
  leftToPayNextYearRealAmount: Decimal!
  leftToPayReportYearAmount: Decimal!
  leftToPayReportYearRealAmount: Decimal!
  leftVacationMoneyBaseAmount: Decimal!
  leftVacationMoneyBaseRealAmount: Decimal!
  municipality: Municipality!
  municipalityTaxPercentage: Decimal!
  paidNextYearAmount: Decimal!
  paidNextYearPaychecks: [Paycheck!]!
  paidReportYearAmount: Decimal!
  shouldExcludeAmounts: Boolean!
  vacationMoneyAmount: Decimal!
  vacationMoneyBaseAmount: Decimal!
  vacationMoneyPercentage: Decimal!
  workRelation: WorkRelation!
}

type ReportYearlyReportForEmployee {
  calculationType: PaycheckLineCalculationTypeEnum!
  car: Car
  department: Department
  description: String!
  number: Int!
  project: Project
  quantity: Decimal
  rate: Decimal
  sum: Decimal!
  vacationMoneyBaseAmount: Decimal!
  workRelation: WorkRelation!
}

input RequestAccessToUnitInput {
  clientMutationId: String
  unitId: ID!
}

type RequestAccessToUnitPayload {
  clientMutationId: String
  unit: Unit
}

enum RoundingTypeEnum {
  DISABLED
  UP
  DOWN
  NEAREST
}

type SalaryTaxDeduction {
  amount: Decimal
  error: String
}

type SettingsVacationMoneyReport {
  excludeNegativeAmountsTo: Decimal!
  excludePositiveAmountsTo: Decimal!
  id: ID!
}

input SettingsVacationMoneyReportSave {
  unitId: ID!
  year: Int!
  excludePositiveAmountsTo: Decimal
  excludeNegativeAmountsTo: Decimal
}

input SettingsVacationMoneyReportSaveInput {
  clientMutationId: String
  settingsVacationMoneyReport: SettingsVacationMoneyReportSave!
}

type SettingsVacationMoneyReportSavePayload {
  clientMutationId: String
  settingsVacationMoneyReport: SettingsVacationMoneyReport!
}

type Subscription {
  invoiceChanged(invoiceId: ID!): InvoiceChangedPayload!
}

type SubUnit {
  department: Department
  id: ID!
  name: String!
  organizationNumber: String!
  workRelations: [WorkRelation!]!
}

input SubUnitCreate {
  name: String!
  organizationNumber: String!
  departmentId: ID
  unitId: ID!
}

input SubUnitCreateInput {
  clientMutationId: String
  subUnit: SubUnitCreate!
}

type SubUnitCreatePayload {
  clientMutationId: String
  subUnit: SubUnit
}

input SubUnitDeleteInput {
  clientMutationId: String
  id: ID!
}

type SubUnitDeletePayload {
  clientMutationId: String
  subUnit: SubUnit
}

input SubUnitUpdate {
  name: String
  organizationNumber: String
  departmentId: ID
  id: ID!
}

input SubUnitUpdateInput {
  clientMutationId: String
  subUnit: SubUnitUpdate!
}

type SubUnitUpdatePayload {
  clientMutationId: String
  subUnit: SubUnit
}

enum SupplierPartyReferenceSettingEnum {
  FULL_NAME
  FIRST_NAME
  LAST_NAME
}

type TaxDeductionToPayTaxDeductionToPayMonth {
  kid: String!
  month: Int!
  paychecks: [TaxDeductionToPayTaxDeductionToPayPaycheck!]!
  paymentDates: [TaxDeductionToPayTaxDeductionToPayPaymentDate!]!
}

type TaxDeductionToPayTaxDeductionToPayPaycheck {
  amount: Decimal!
  dueDate: Date!
  employeeName: String!
  garnishmentAmount: Decimal!
  garnishmentSamordnetAmount: Decimal!
  id: ID!
  number: Int!
  taxDeductionAmount: Decimal!
}

type TaxDeductionToPayTaxDeductionToPayPaymentDate {
  dueDate: Date!
  garnishmentAmount: Decimal!
  garnishmentSamordnetAmount: Decimal!
  taxDeductionAmount: Decimal!
}

type Unit {
  active: Boolean!
  address: String
  ameldingAccountSelections: [AmeldingAndBookkeepingReconciliationReportAccountSelection!]!
  canReceiveEhf3: Boolean!
  cars: [Car!]!
  city: String
  closedDate: Date
  country: Country!
  customers: [Customer!]!
  departments: [Department!]!
  email: String
  employeeUser: User
  employees: [Employee!]!
  fax: String
  foretaksRegisteredSince: Date
  generalInvoiceStatistics(from: String!, to: String!, fields: [String!]!, interval: ReportIntervalEnum = MONTHLY): [ReportGeneralInvoiceStatistic!]!
  highestPriorityIdentity: Identity!
  id: ID!
  identities: [Identity!]!
  invoices: [Invoice!]!
  isCompany: Boolean!
  locale: String!
  mainPaycheckLineTemplates: [MainPaycheckLineTemplate!]!
  mobile: String
  municipalities: [Municipality!]!
  municipalitySelections: [MunicipalitySelection!]!
  name: String!
  occupationSelections: [OccupationSelection!]!
  occupations: [Occupation!]!
  openedDate: Date
  orders: [Order!]!
  paycheckPeriods(year: Int = null): [PaycheckPeriod!]!
  paymentMethods: [PaymentMethod!]!
  pensionUnitSelections: [PensionUnitSelection!]!
  phone: String
  productGroups: [ProductGroup!]!
  productSupplierUnits: [Unit!]!
  productVariantHolders: [ProductVariantHolder!]!
  projects: [Project!]!
  recurringOrders: [RecurringOrder!]!
  subUnits: [SubUnit!]!
  unitSetting: UnitSetting!
  unofficialName: String
  users(withSuperAdmins: Boolean = false): [User!]!
  vatRegulation: Boolean!
  warehousePatches: [WarehousePatch!]!
  website: String
  webstoreApiTokens: [WebstoreApiToken!]!
  workRelations: [WorkRelation!]!
  zip: String
}

input UnitCreate {
  isCompany: Boolean!
  name: String!
  unofficialName: String
  address: String!
  city: String!
  zip: String!
  countryCode: String!
  identities: [IdentityCreate!]!
}

input UnitCreateInput {
  clientMutationId: String
  unit: UnitCreate!
}

type UnitCreatePayload {
  clientMutationId: String
  unit: Unit
}

type UnitInvoiceSetting {
  bban: String
  currency: Currency!
  currencyCode: String!
  customNote: String
  customerCountry: Country!
  customerCreditDays: Int
  defaultProductUnitOfMeasureCode: String
  displaySettings: UnitSettingDisplaySettings!
  efakturaEnabled: Boolean!
  exports: Boolean!
  iban: String
  id: ID
  invoiceEmailCopy: Boolean!
  kidLength: Int
  kidModDigit: Int
  legalNotes: [String!]!
  orderSaveLockConfirmation: Boolean!
  overdueNoticeCharge: Decimal
  paymentMethods: Boolean!
  productGroups: Boolean!
  startingInvoiceNumber: Int!
  startingOrderNumber: Int!
  supplierPartyReferenceSetting: SupplierPartyReferenceSettingEnum!
  swift: String
  taxInclusiveAmountRounding: RoundingTypeEnum!
  usesInterestInvoices: Boolean!
  usesKid: Boolean!
  usesOverdueNotices: Boolean!
}

input UnitInvoiceSettingBase {
  usesKid: Boolean
  kidLength: Int
  kidModDigit: Int
  customerCreditDays: Int
  startingOrderNumber: Int
  startingInvoiceNumber: Int
  customerCountryCode: String
  currencyCode: String
  legalNotes: [String!]
  customNote: String
  displaySettings: UnitSettingDisplaySettingBase
  defaultProductUnitOfMeasureCode: String
  invoiceEmailCopy: Boolean
  supplierPartyReferenceSetting: SupplierPartyReferenceSettingEnum
  exports: Boolean
  productGroups: Boolean
  paymentMethods: Boolean
  taxInclusiveAmountRounding: RoundingTypeEnum
  usesOverdueNotices: Boolean
  overdueNoticeCharge: Decimal
  usesInterestInvoices: Boolean
  efakturaEnabled: Boolean
  orderSaveLockConfirmation: Boolean
}

type UnitOfMeasure {
  code: String!
  description: String
  name: String!
  status: String!
  symbol: String
}

type UnitPaycheckSetting {
  altinn3AuthAs: String
  altinn3SystemUserStatus: UnitPaycheckSettingsAltinn3SystemUserStatusEnum!
  calculationForTax: String!
  currency: Currency!
  currencyCode: String!
  defaultCreditDays: Int!
  defaultVacationMoneyPercentage: Decimal!
  defaultWorkRelation: UnitSettingDefaultWorkRelation!
  id: ID
  municipality: Municipality
  sendAltin3Amelding: Boolean!
  startingPaycheckNumber: Int!
}

input UnitPaycheckSettingBase {
  currencyCode: String
  startingPaycheckNumber: Int
  municipalityId: ID
  calculationForTax: String
  altinn3AuthAs: String
  defaultCreditDays: Int
  defaultVacationMoneyPercentage: Decimal
  defaultWorkRelation: UnitSettingDefaultWorkRelationBase
}

enum UnitPaycheckSettingsAltinn3SystemUserStatusEnum {
  no_system_user
  request_in_progress
  request_rejected
  registered
}

type UnitSetting {
  companyNameOption: CompanyNameOptionEnum!
  id: ID
  logo: Attachment!
  oldLogos: [Attachment!]!
  savedAt: DateTime
  savedBy: User
  unitInvoiceSetting: UnitInvoiceSetting!
  unitPaycheckSetting: UnitPaycheckSetting!
}

input UnitSettingBase {
  unitId: ID!
  logo: FileUpload
  unitInvoiceSetting: UnitInvoiceSettingBase
  unitPaycheckSetting: UnitPaycheckSettingBase
  companyNameOption: CompanyNameOptionEnum
}

type UnitSettingDefaultWorkRelation {
  durationType: AltinnEmploymentDurationTypeEnum
  employmentPercentage: Decimal
  employmentType: AltinnEmploymentTypeEnum
  hoursEveryWeekWithFullEmployment: Decimal
  occupationId: ID
  shiftType: AltinnShiftTypeEnum
  subUnitId: ID
}

input UnitSettingDefaultWorkRelationBase {
  subUnitId: ID
  occupationId: ID
  employmentType: AltinnEmploymentTypeEnum
  durationType: AltinnEmploymentDurationTypeEnum
  shiftType: AltinnShiftTypeEnum
  hoursEveryWeekWithFullEmployment: Decimal
  employmentPercentage: Decimal
}

input UnitSettingDisplaySettingBase {
  invoiceLineCar: Boolean!
  invoiceLineProject: Boolean!
  invoiceLineDepartment: Boolean!
  invoiceLineOrderedQuantity: Boolean!
  invoiceLineTaxAmount: Boolean!
  invoiceLineAllowanceCharge: Boolean!
  invoiceAllowanceCharge: Boolean!
  invoiceCar: Boolean!
  invoiceProject: Boolean!
  invoiceDepartment: Boolean!
}

type UnitSettingDisplaySettings {
  invoiceAllowanceCharge: Boolean!
  invoiceCar: Boolean!
  invoiceDepartment: Boolean!
  invoiceLineAllowanceCharge: Boolean!
  invoiceLineCar: Boolean!
  invoiceLineDepartment: Boolean!
  invoiceLineOrderedQuantity: Boolean!
  invoiceLineProject: Boolean!
  invoiceLineTaxAmount: Boolean!
  invoiceProject: Boolean!
}

input UnitSettingSaveInput {
  clientMutationId: String
  unitSetting: UnitSettingBase!
}

type UnitSettingSavePayload {
  clientMutationId: String
  unitSetting: UnitSetting
}

type User {
  active: Boolean!
  cellphone: String
  cellphoneCountry: Country!
  currentUnit: Unit!
  firstName: String
  id: ID!
  lastName: String
  locale: String!
  login: String!
  name: String
  permissions: Permissions!
  units(offset: Int = null, limit: Int = 200, term: String = null): [Unit!]!
}

input UserEmployee {
  login: String
  cellphone: String!
  cellphoneCountryCode: String
}

input VacationMoneySummaryEmailInput {
  clientMutationId: String
  unitId: ID!
  year: Int!
  recipients: [String!]!
}

type VacationMoneySummaryEmailPayload {
  clientMutationId: String
  success: Boolean!
}

type WarehousePatch {
  comment: String
  createdAt: DateTime!
  createdBy: User!
  date: Date!
  id: ID!
  supplierUnit: Unit
  unit: Unit!
  warehousePatchLines: [WarehousePatchLine!]!
}

input WarehousePatchCreate {
  unitId: ID!
  supplierUnitId: ID
  comment: String
  date: Date!
  warehousePatchLines: [WarehousePatchLineCreate!]!
}

input WarehousePatchCreateInput {
  clientMutationId: String
  warehousePatch: WarehousePatchCreate!
}

type WarehousePatchCreatePayload {
  clientMutationId: String
  warehousePatch: WarehousePatch
}

type WarehousePatchLine {
  checkpoint: Boolean!
  id: ID!
  product: Product!
  productName: String!
  productNumber: String!
  purchasePrice: Decimal!
  quantity: Decimal!
}

input WarehousePatchLineCreate {
  productId: ID!
  quantity: Decimal!
  purchasePrice: Decimal!
  productNumber: String!
  productName: String!
  checkpoint: Boolean!
}

input WarehousePatchLineUpdate {
  productId: ID
  quantity: Decimal
  purchasePrice: Decimal
  productNumber: String
  productName: String
  checkpoint: Boolean
  id: ID
  _destroy: Boolean
}

input WarehousePatchUpdate {
  unitId: ID
  supplierUnitId: ID
  comment: String
  date: Date
  id: ID!
  warehousePatchLines: [WarehousePatchLineUpdate!]
}

input WarehousePatchUpdateInput {
  clientMutationId: String
  warehousePatch: WarehousePatchUpdate!
}

type WarehousePatchUpdatePayload {
  clientMutationId: String
  warehousePatch: WarehousePatch
}

type WarehouseProductReport {
  suppliersData: [WarehouseProductReportSupplier!]!
}

type WarehouseProductReportProduct {
  product: Product!
  quantity: Decimal!
}

type WarehouseProductReportSupplier {
  productsData: [WarehouseProductReportProduct!]!
  unit: Unit
}

type WebstoreApiToken {
  createdBy: User!
  description: String!
  expiryDate: Date
  id: ID!
  tokenValue: String!
}

input WebstoreApiTokenCreate {
  unitId: ID!
  expiryDate: Date
  description: String!
}

input WebstoreApiTokenCreateInput {
  clientMutationId: String
  webstoreApiToken: WebstoreApiTokenCreate!
}

type WebstoreApiTokenCreatePayload {
  clientMutationId: String
  webstoreApiToken: WebstoreApiToken
}

input WebstoreApiTokenDeleteInput {
  clientMutationId: String
  id: ID!
}

type WebstoreApiTokenDeletePayload {
  clientMutationId: String
  webstoreApiToken: WebstoreApiToken
}

type WorkRelation {
  activePaycheckLineTemplates: [PaycheckLineTemplate!]!
  durationType: AltinnEmploymentDurationTypeEnum
  employee: Employee!
  employmentPercentage: Decimal
  employmentPercentageUpdated: Date
  employmentType: AltinnEmploymentTypeEnum!
  endDate: Date
  endDateSentToAltinn(calendarMonth: String): Boolean!
  endReason: AltinnEmploymentEndReasonEnum
  hoursEveryWeekWithFullEmployment: Decimal
  id: ID!
  lastPaycheck: Paycheck
  lastSalaryChange: Date
  leaveAndLayoffs(calendarMonth: String): [WorkRelationLeaveAndLayoff!]!
  leaveAndLayoffsForPeriod(periodId: ID!): [WorkRelationLeaveAndLayoff!]!
  occupation: Occupation
  paycheckDrafts(periodId: ID, noPaycheckOnly: Boolean): [PaycheckDraft!]!
  paycheckLineTemplates(editableFromEmployeePage: Boolean): [PaycheckLineTemplate!]!
  paycheckPrepaymentsSum(year: Int!, untilDate: Date!): Decimal!
  paycheckSums(year: Int!, untilDate: Date!): [PaycheckSum!]!
  paychecks(periodId: ID): [Paycheck!]!
  paychecksForAmelding(calendarMonth: String!): [Paycheck!]!
  pensionEndDate: Date
  samePositionSince: Date
  sentToAltinn(calendarMonth: String): Boolean!
  shiftType: AltinnShiftTypeEnum
  startDate: Date
  subUnit: SubUnit!
  timesheet(calendarMonth: String!): WorkRelationTimesheet
  timesheetComment: String
  yearlyReportForEmployeePdfBase64(year: Int!): String
}

input WorkRelationEmployeeSave {
  occupationId: ID
  startDate: Date
  endDate: Date
  pensionEndDate: Date
  endReason: AltinnEmploymentEndReasonEnum
  samePositionSince: Date
  shiftType: AltinnShiftTypeEnum
  employmentType: AltinnEmploymentTypeEnum
  employmentPercentage: Decimal
  employmentPercentageUpdated: Date
  hoursEveryWeekWithFullEmployment: Decimal
  lastSalaryChange: Date
  durationType: AltinnEmploymentDurationTypeEnum
  id: ID
  subUnitId: ID
  _destroy: Boolean
  leaveAndLayoffs: [WorkRelationLeaveAndLayoffSave!]
}

type WorkRelationLeaveAndLayoff {
  description: AltinnLeaveAndLayoffDescriptionEnum!
  endDate: Date
  id: ID!
  isEndDateSentToAltinn: Boolean!
  isSentToAltinn: Boolean!
  leaveId: String!
  percentageLeave: Decimal!
  startDate: Date!
  workRelation: WorkRelation!
}

input WorkRelationLeaveAndLayoffSave {
  id: ID
  _destroy: Boolean
  startDate: Date
  endDate: Date
  percentageLeave: Decimal
  leaveId: String
  description: AltinnLeaveAndLayoffDescriptionEnum
}

type WorkRelationTimesheet {
  calendarMonth: String!
  days: [WorkRelationTimesheetDay!]!
  id: ID!
  paidMinutesSum: Int!
  status: WorkRelationTimesheetStatusEnum!
  timeStamps: [WorkRelationTimesheetTimeStamp!]!
  totalMinutesSum: Int!
  workRelation: WorkRelation!
}

type WorkRelationTimesheetBreak {
  endHhmm: String!
  startHhmm: String!
}

input WorkRelationTimesheetBreakInput {
  startHhmm: String
  endHhmm: String
}

input WorkRelationTimesheetCommentSaveInput {
  clientMutationId: String
  workRelationId: ID!
  timesheetComment: String
}

type WorkRelationTimesheetCommentSavePayload {
  clientMutationId: String
  workRelation: WorkRelation
}

type WorkRelationTimesheetDay {
  breakMinutes: Int!
  breaks: [WorkRelationTimesheetBreak!]!
  date: Date!
  endHhmm: String
  id: ID!
  startHhmm: String
  timeStamps: [WorkRelationTimesheetDayTimeStamp!]!
}

input WorkRelationTimesheetDayInput {
  date: Date!
  startHhmm: String
  endHhmm: String
  breakMinutes: Int
  breaks: [WorkRelationTimesheetBreakInput!]
  timeStamps: [WorkRelationTimesheetDayTimeStampInput!]
  totalMinutes: Int
  paidMinutes: Int
}

type WorkRelationTimesheetDayTimeStamp {
  endHhmm: String!
  key: String!
  startHhmm: String!
}

input WorkRelationTimesheetDayTimeStampInput {
  key: String!
  startHhmm: String
  endHhmm: String
}

input WorkRelationTimesheetSaveAttributes {
  workRelationId: ID!
  calendarMonth: String!
  days: [WorkRelationTimesheetDayInput!]!
  timeStamps: [WorkRelationTimesheetTimeStampInput!]
  totalMinutesSum: Int!
  paidMinutesSum: Int!
}

input WorkRelationTimesheetSaveInput {
  clientMutationId: String
  timesheet: WorkRelationTimesheetSaveAttributes!
}

type WorkRelationTimesheetSavePayload {
  clientMutationId: String
  timesheet: WorkRelationTimesheet
}

enum WorkRelationTimesheetStatusEnum {
  draft
  submitted
}

input WorkRelationTimesheetSubmitInput {
  clientMutationId: String
  workRelationId: ID!
  calendarMonth: String!
}

type WorkRelationTimesheetSubmitPayload {
  clientMutationId: String
  timesheet: WorkRelationTimesheet
}

type WorkRelationTimesheetTimeStamp {
  key: String!
  name: String!
  totalMinutes: Int!
}

input WorkRelationTimesheetTimeStampInput {
  key: String!
  name: String!
  totalMinutes: Int
}

input YearlyReportForEmployeeSendToFbInput {
  clientMutationId: String
  unitId: ID!
  year: Int!
}

type YearlyReportForEmployeeSendToFbPayload {
  clientMutationId: String
  sentPdfs: Int
}
`;
